import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from '@reach/router'
import $ from 'jquery'
import { Markup } from 'interweave'
// import { deleteSharp } from "@helpers/helper.map"
import { useGetAdvancedLocationsQuery } from '@apis/middlewareTokkoApi/properties'
import useQuerySummary from '@hooks/useQuerySummary'
import { ROUTES } from '../../../../routes'
import {
  DefaultPropertyFilter,
  FilterPropertiesTokkoQuery,
  FiltersProperties,
  RealEstateDataPageComponentData,
  StatePropertiesSlice,
} from 'types'
import Filters_2 from '../2'
import {
  checkCurrentFilters,
  updateFilters,
  getView,
  checkEnvironment,
  getTypeCount,
  getTagCount,
  getGenerals,
  getEnvironment,
  getServices,
  checkBedroom,
  getGrandfathers,
  getFathers,
  getChildrens,
  normalizeName,
  getArrayTypesById,
  updateRouter,
  loadFiltersRoute,
} from '@helpers/helper.filters'
import { reduxUpdateFilters } from '@slices/propertiesSlice'
import useQueryGenerals from '@hooks/useQueryGenerals'
import { Collapse } from 'react-bootstrap'
import { useGetLocationsQuery } from '@apis/mediacore/owner'

const Filters_Bar_4 = ({
  auxFilters,
  setAuxFilters,
  setMenu,
  menu,
  locationsAdv,
  global_data,
  groupIds,
  groupName,
  idsPredefinidos,
}: {
  viewId: number
  auxFilters: any
  setAuxFilters: any
  setMenu: any
  menu: boolean
  locationsAdv: boolean
} & RealEstateDataPageComponentData & {
    groupIds?: number[]
    groupName?: string
    idsPredefinidos: number[]
  }) => {
  const lowPrice = true
  const { filters } = useSelector(
    (state: { properties: StatePropertiesSlice }) => state.properties,
  )!
  const api_key = global_data.pageConfig.keys.tokko
  const { divisionPath } = global_data
  const {
    SALE_VIEW_DATA: SALE,
    RENT_VIEW_DATA: RENT,
    TEMPORARY_VIEW_DATA: TEMPORARY,
  } = JSON.parse(process.env.extra_data || ROUTES)

  const history = useLocation()
  const [locations, setLocations] = useState<any[]>([])

  const dispatch = useDispatch()

  const [location, setLocation] = useState(history.pathname.split('/'))
  const [searcher, setSearcher] = useState('')
  const [searcherGeneral, setSearcherGeneral] = useState('')

  const [openType, setOpenType] = useState(false)
  const [openOperation, setOpenOperation] = useState(false)
  const [openLocation, setOpenLocation] = useState(false)
  const [openEnvironment, setOpenEnvironment] = useState(false)
  const [openMinEnvironment, setOpenMinEnvironment] = useState(false)
  const [openMaxEnvironment, setOpenMaxEnvironment] = useState(false)
  const [openMinBedrooms, setOpenMinBedrooms] = useState(false)
  const [openMaxBedrooms, setOpenMaxBedrooms] = useState(false)

  const google_map = ''

  const [isMounted, setIsMounted] = useState(false)

  const [openPrice, setOpenPrice] = useState(false)
  const [openSurface, setOpenSurface] = useState(false)
  const [openGenerals, setOpenGenerals] = useState(false)
  const [openTypeEnvoirments, setOpenTypeEnvoirments] = useState(false)
  const [openServices, setOpenServices] = useState(false)
  const [openAge, setOpenAge] = useState(false)

  const [environments, setEnvironments] = useState({ min: '', max: '' })
  const [bedrooms, setBedrooms] = useState({ min: '', max: '' })

  // const [auxFilters,setAuxFilters] = useState<any>()
  const API_KEY = global_data.pageConfig.keys.tokko
  const { allSummaryData } = useQuerySummary({ API_KEY })
  const { allSummaryData: summaryByOperation } = useQuerySummary({
    OPERATION: filters?.operation,
    API_KEY,
  })

  const { allSummaryData: summaryGenerals } = useQueryGenerals({
    OPERATION: filters?.operation,
    TYPE: API_KEY ? getArrayTypesById(filters.type, allSummaryData) : filters.type,
    API_KEY,
  })

  const { data: advancedLocationsData, isLoading: isLoadingadvancedLocations } =
    process.env.GATSBY_USE_MIDDLEWARE_V2?.toLowerCase() == 'true'
      ? useGetLocationsQuery({ OPERATION: filters?.operation, TYPE: filters?.type })
      : useGetAdvancedLocationsQuery({
          API_KEY,
          operation: filters?.operation,
          types: filters?.type,
          // types: filters?.type.map((element) => element.id),
        })

  const [collapse_items, setCollapse_items] = useState<
    {
      id: string
      state: boolean
    }[]
  >([])

  const [collapse_boxes, setCollapse_boxes] = useState({
    operation: true,
    type: false,
    location: false,
    environments: false,
    bedrooms: false,
    age: false,
    price: false,
    surface: false,
    generals: false,
    services: false,
    amenities: false,
  })

  const [auxiliarValuesPrice, setAuxiliarPrice] = useState<{
    priceType: string
    priceMin: number | string
    priceMax: number | string
  }>({
    priceType: '',
    priceMin: '',
    priceMax: '',
  })

  const [auxiliarValuesSurface, setAuxiliarSurface] = useState({
    surfaceType: '',
    surfaceMin: '',
    surfaceMax: '',
  })

  const pricesDefault = [
    20000, 40000, 60000, 80000, 100000, 200000, 400000, 600000, 800000, 1000000,
  ]

  const [helpers, setHelpers] = useState({
    minprice: 0,
    maxprice: 0,
    minarea: 0,
    maxarea: 0,
  }) // minprice,maxprice,minarea,maxarea

  useEffect(() => {
    setIsMounted(true)
    if (filters?.operation === '') {
      setAuxFilters({ ...filters, operation: getView(history) })
    }
  }, [])

  useEffect(() => {
    if (filters?.operation && filters !== auxFilters && checkContent(filters)) {
      setAuxFilters(filters)
      if (checkCurrentFilters(filters, 'surface-type', 'total')) {
        setAuxiliarSurface({
          ...auxiliarValuesSurface,
          surfaceType: 'total',
          surfaceMin: filters.surface?.surfaceMin!,
          surfaceMax: filters.surface?.surfaceMax!,
        })
      }
      if (checkCurrentFilters(filters, 'surface-type', 'cubierta')) {
        setAuxiliarSurface({
          ...auxiliarValuesSurface,
          surfaceType: 'cubierta',
          surfaceMin: filters.surface?.surfaceMin!,
          surfaceMax: filters.surface?.surfaceMax!,
        })
      }
      if (checkCurrentFilters(filters, 'price-type', 'pesos')) {
        setAuxiliarPrice({
          ...auxiliarValuesPrice,
          priceType: 'pesos',
          priceMin: filters.price.priceMin!,
          priceMax: filters.price.priceMax!,
        })
      }
      if (checkCurrentFilters(filters, 'price-type', 'dolares')) {
        setAuxiliarPrice({
          ...auxiliarValuesPrice,
          priceType: 'dolares',
          priceMin: filters.price.priceMin!,
          priceMax: filters.price.priceMax!,
        })
      }
    }
    // else{
    //   setAuxFilters({...filters,operation:getView(history)})
    // }
    if (filters?.surface?.type === '') {
      setAuxiliarSurface({
        surfaceType: '',
        surfaceMin: '',
        surfaceMax: '',
      })
    }
    if (filters?.price?.type === '') {
      setAuxiliarPrice({
        priceType: '',
        priceMin: '',
        priceMax: '',
      })
    }
    if (filters?.environments === '') {
      setEnvironments({ min: '', max: '' })
    }
    if (filters?.bedrooms === '') {
      setBedrooms({ min: '', max: '' })
    }
    const route = updateRouter(filters, undefined, divisionPath)
    // navigate(route!)
  }, [filters])

  useEffect(() => {
    if (allSummaryData) {
      for (let index = 0; index < allSummaryData.objects.locations.length; index++) {
        if (locations.length <= 0) {
          setLocations((locations: any) => [
            ...locations,
            allSummaryData.objects.locations[index].location_name,
          ])
        }
      }
      if (screen.width < 992) {
        const height = $('#header').height() || '0px'
        const header: any = document.querySelector('header')
        $('.handle-filter-bar.a').css('position', 'sticky')
        if (header.classList.contains('position-fixed')) {
          $('.handle-filter-bar.a').css('top', height)
        } else {
          $('.handle-filter-bar.a').css('top', '0')
        }
      }
    }
  }, [allSummaryData])

  useEffect(() => {
    if (auxFilters) {
      dispatch(reduxUpdateFilters(auxFilters))
    }
  }, [auxFilters])

  useEffect(() => {
    let interval = ''
    if (filters?.environments !== `${environments.min}-${environments.max}`) {
      if (environments.min || environments.max) {
        if (environments.min !== '' || environments.max !== '') {
          interval = `${environments.min}-${environments.max}`
        }
        if (environments.min !== '' && environments.max === '') {
          interval = `${environments.min}-99`
        }
        if (environments.max !== '' && environments.min === '') {
          interval = `0-` + environments.max
        }
        return updateFilters(setAuxFilters, auxFilters, 'environments', interval)
      }
    }
  }, [environments])

  useEffect(() => {
    let interval = ''
    if (filters?.bedrooms !== `${bedrooms.min}-${bedrooms.max}`) {
      if (bedrooms.min || bedrooms.max) {
        if (bedrooms.min !== '' && bedrooms.max !== '') {
          interval = `${bedrooms.min}-${bedrooms.max}`
        }
        if (bedrooms.min !== '' && bedrooms.max === '') {
          interval = `${bedrooms.min}-99`
        }
        if (bedrooms.max !== '' && bedrooms.min === '') {
          interval = `0-` + bedrooms.max
        }
        return updateFilters(setAuxFilters, auxFilters, 'bedrooms', interval)
      }
    }
  }, [bedrooms])

  if (isMounted) {
    $(document).ready(function () {
      $(document).on('click', function (event) {
        if (!$(event.target).closest('.not-closer').length) {
          // Aquí colocas el código que deseas ejecutar cuando se hace clic en cualquier lugar que no sea .float-select
          setOpenAge(false)
          setOpenSurface(false)
          setOpenServices(false)
          setOpenTypeEnvoirments(false)
          setOpenGenerals(false)
          setOpenPrice(false)
          setOpenEnvironment(false)
          setOpenType(false)
          setOpenLocation(false)
          setOpenOperation(true)
        }
      })
    })
  }

  //Carga de filtros.

  const [filtersLoading, setFiltersLoading] = useState(true)
  const [filtersLoaded, setFiltersLoaded] = useState(false)

  useEffect(() => {
    // Ejecuto la accion para obtener los filtros
    // if (allSummaryData || advancedLocationsData) {
    if (location && !filtersLoaded && allSummaryData) {
      if (location) {
        loadFiltersRoute(
          location,
          setAuxFilters,
          filters,
          allSummaryData,
          [],
          setFiltersLoading,
          advancedLocationsData,
          allSummaryData,
        )
        if (API_KEY) {
          setFiltersLoaded(true)
        }
      }
      // }
    }
    // }, [allSummaryData, advancedLocationsData, history])
  }, [allSummaryData, advancedLocationsData, history])

  const checkContent = (filters: FiltersProperties) => {
    const prot_filter: any = {
      location: [],
      type: [],
      operation: '',
      environments: '',
      bedrooms: '',
      age: '',
      address: '',
      price: {
        type: '',
        is_off: false,
        priceMin: 0,
        priceMax: 0,
      },
      surface: {
        type: '',
        surfaceMin: '',
        surfaceMax: '',
      },
      environments_types: [],
      generals: [],
      services: [],
      specials: [],
    }
    if (filters === prot_filter) {
      return false
    }
    return true
  }

  const checkEnvironmentExist = () => {
    let counter = 0
    for (let index = 0; index < 10; index++) {
      if (
        checkEnvironment(summaryGenerals?.objects, index)?.amount! > 0 &&
        checkEnvironment(summaryGenerals?.objects, index)?.count! > 0
      ) {
        counter++
      }
    }
    if (counter > 0) {
      return true
    }
    return false
  }

  const checkBedroomExist = () => {
    let counter = 0
    for (let index = 0; index < 10; index++) {
      if (
        checkBedroom(summaryGenerals?.objects, index)?.amount! > 0 &&
        checkBedroom(summaryGenerals?.objects, index)?.count! > 0
      ) {
        counter++
      }
    }
    if (counter > 0) {
      return true
    }
    return false
  }

  const sendAuxiliar = () => {
    updateFilters(setAuxFilters, auxFilters, 'price-type', auxiliarValuesPrice.priceType)
    updateFilters(setAuxFilters, auxFilters, 'price-min', auxiliarValuesPrice.priceMin)
    updateFilters(setAuxFilters, auxFilters, 'price-max', auxiliarValuesPrice.priceMax)
    updateFilters(setAuxFilters, auxFilters, 'surface-type', auxiliarValuesSurface.surfaceType)
    updateFilters(setAuxFilters, auxFilters, 'surface-min', auxiliarValuesSurface.surfaceMin)
    updateFilters(setAuxFilters, auxFilters, 'surface-max', auxiliarValuesSurface.surfaceMax)
  }

  const cleanerPolygon = () => {
    // if (google_map) {
    //   deleteSharp(drawnPolygon, dispatch, REDUX_UPDATE_DRAWN_POLYGON)
    // } else {
    //   dispatch(REDUX_UPDATE_POLYGON_COORDINATES([]))
    //   dispatch(REDUX_UPDATE_COORDINATES([]))
    // }
  }

  const updateEnvironment = (type: string, value: any) => {
    if (type === 'min') {
      return setEnvironments({ ...environments, min: value })
    }
    if (type === 'max') {
      return setEnvironments({ ...environments, max: value })
    }
  }

  const updateBedroom = (type: string, value: any) => {
    if (type === 'min') {
      return setBedrooms({ ...bedrooms, min: value })
    }
    if (type === 'max') {
      return setBedrooms({ ...bedrooms, max: value })
    }
  }

  const handleInputPriceMin = (_price: string) => {
    const inputValue = _price

    // Eliminar los puntos (.) antes de analizar el número
    const cleanedValue = inputValue.replace(/\./g, '')

    // Convertir el valor limpio en un número
    const numericValue = parseFloat(cleanedValue)

    // Actualizar el estado con el valor numérico
    setAuxiliarPrice({ ...auxiliarValuesPrice, priceMin: numericValue.toString() })
  }
  const handleInputPriceMax = (_price: string) => {
    const inputValue = _price

    // Eliminar los puntos (.) antes de analizar el número
    const cleanedValue = inputValue.replace(/\./g, '')

    // Convertir el valor limpio en un número
    const numericValue = parseFloat(cleanedValue)

    // Actualizar el estado con el valor numérico
    setAuxiliarPrice({ ...auxiliarValuesPrice, priceMax: numericValue?.toString() })
  }

  const checkCitiesActive = (parent: any) => {
    // // Se fija si todos los hijos de un padre estan activos

    let grandfathers: any = getChildrens(parent)

    if (Object.keys(parent[1]).length === 2) {
      if (
        filters?.location.find((location) => location?.id?.toString() === parent[1].id.toString())
      ) {
        return true
      }
      return false
    }
    for (const children of grandfathers) {
      if (filters?.location.find((element) => element.id === children[1]?.id)) {
      } else {
        return false
      }
    }
    return true
  }

  const updateLocationByParent = (item: any) => {
    let newLocations = filters?.location!
    for (let i = 0; i < getGrandfathers(advancedLocationsData).length; i++) {
      // Me fijo si el abuelo tiene todos los hijos activos, los desactivo y activo solo este padre que estoy clickeando.
      if (
        getFathers(getGrandfathers(advancedLocationsData)[i]).find(
          (element) => element[0] === item[0],
        )
      ) {
        if (checkAllFatherActives(getGrandfathers(advancedLocationsData)[i])) {
          //Si llegan a estar todos los hijos activos, los desactivo y dejo solo este activo.
          for (let j = 0; j < getFathers(getGrandfathers(advancedLocationsData)[i]).length; j++) {
            // Recorro todos los "Hermanos" de este padre
            const brother: any = getFathers(getGrandfathers(advancedLocationsData)[i])[j]
            for (let c = 0; c < getChildrens(brother).length; c++) {
              // Recorro los hijos de los hermanos y tambien los deshabilito.
              let children: any = getChildrens(brother)[c]
              newLocations = newLocations.filter((location) => location.id !== children[1]?.id!)
            }
            newLocations = newLocations.filter((location) => location.id !== brother[1]?.id!) //Saco todos los hermanos
          }

          const childrens: any = getChildrens(item)

          if (childrens.length > 0) {
            for (let c = 0; c < childrens.length; c++) {
              newLocations = [
                ...newLocations,
                {
                  id: childrens[c][1]?.id!,
                  name: childrens[c][0],
                },
              ]
            }
            return updateFilters(setAuxFilters, filters, 'allLocations', newLocations) //Si este padre tiene hijos, los activo a ellos.
          }
          return updateFilters(setAuxFilters, filters, 'allLocations', [
            ...newLocations,
            { id: item[1].id, name: item[0] },
          ]) //Si este padre tiene hijos, los activo a ellos.
        }
      }
    }
    if (Object.keys(item[1]).length === 2) {
      // Si no tiene hijos el padre (CHEQUEAR ESTO)
      if (newLocations.find((element) => element.id === item[1].id))
        return updateFilters(
          setAuxFilters,
          filters,
          'allLocations',
          newLocations.filter((element) => element.id !== item[1].id),
        )
      return updateFilters(setAuxFilters, filters, 'allLocations', [
        ...newLocations,
        { id: item[1].id, name: item[0] },
      ])
    }
    if (checkCitiesActive(item)) {
      // Si todos los hijos del padre están activos, los desactivo.
      const childrens: any = getChildrens(item)
      for (const children of childrens) {
        newLocations = newLocations.filter((element) => element.id !== children[1]?.id)
      }
      return updateFilters(
        setAuxFilters,
        filters,
        'allLocations',
        newLocations.filter((element) => element.id !== item[1].id),
      ) //Si este padre tiene hijos, los activo a ellos.
    }

    const childrens: any = getChildrens(item)
    for (const children of childrens) {
      newLocations = newLocations.filter((element) => element.id !== children[1]?.id)
      newLocations.push({ id: children[1]?.id, name: children[0] })
    }
    return updateFilters(setAuxFilters, filters, 'allLocations', [
      ...newLocations,
      { id: item[1].id, name: item[0] },
    ]) //Si este padre tiene hijos, los activo a ellos.
  }

  const updateLocationByChildren = (item: any) => {
    let newLocations = filters?.location
    if (filters?.location.find((element) => element.id === item.id)) {
      return updateFilters(
        setAuxFilters,
        filters,
        'allLocations',
        newLocations?.filter((element) => element.id !== item.id),
      )
    }
    let loc_response = newLocations?.map((a) => a)
    loc_response?.push({ id: item.id, name: item.name, type: 'neighborhood' })
    return updateFilters(setAuxFilters, filters, 'allLocations', loc_response)
  }

  const updateLocationByGrandFather = (item: any) => {
    const fathers: any = getFathers(item)
    const parentFormated = fathers.map(
      // Formateo todos los hijos de este abuelo.
      (element: any) => ({ id: element[1]?.id, name: element[0] }),
    )
    let newLocations = []
    for (let i = 0; i < filters?.location?.length!; i++) {
      //Recorro los filtros activos para eliminar todos los hijos de este abuelo activo.
      if (parentFormated.find((element: any) => element.id === filters?.location[i].id)) {
        //Si encuentro un hijo activo, no lo agrego.
      } else {
        newLocations.push({
          id: filters?.location[i].id,
          name: filters?.location[i].name,
        }) //Mantengo los filtros activos que no pertenecer a este abuelo.
      }
    }
    if (!checkAllFatherActives(item)) {
      newLocations = [...newLocations, ...parentFormated] //Si no estan todos los hijos de este abuelo activos, los activo.
    } else {
      for (let i = 0; i < getFathers(item).length; i++) {
        const father: any = getFathers(item)[i]
        for (let c = 0; c < getChildrens(father).length; c++) {
          const children: any = getChildrens(father)[c]
          newLocations = newLocations.filter((element) => element.id !== children[1]?.id) // Elimino los nietos que estan activos.
        }
      }
    }
    return updateFilters(setAuxFilters, filters, 'allLocations', newLocations)
  }

  const checkAllFatherActives = (item: any) => {
    // Se fija si todos los hijos de un abuelo estan activos
    const fathers: any = getFathers(item)
    for (const father of fathers) {
      if (filters?.location.find((element) => element.id === father[1]?.id)) {
      } else {
        return false
      }
    }
    return true
  }

  function toMarkup(text: string, searcherOperation: string) {
    if (searcherOperation === '') {
      return text.toLowerCase()
    }
    text = text.replaceAll(
      searcherOperation.toLowerCase(),
      '<b>' + searcherOperation.toLowerCase() + '</b>',
    )
    return text
  }

  const checkNameActive = (parent: any) => {
    if (filters?.location.find((element) => element?.name?.toString() === parent[0].toString())) {
      return true
    }
    return false
  }

  const groupLocations = () => {
    const locations_grouped = []
    const listLocationLite = { meta: '' }
    if (API_KEY) {
      if (!advancedLocationsData?.meta || listLocationLite?.meta) {
        return []
      }
      for (let grandfather of getGrandfathers(advancedLocationsData)) {
        if (checkAllFatherActives(grandfather)) {
          locations_grouped.push({ ...grandfather, is: 'grandfather' })
        } else {
          for (let father of getFathers(grandfather)) {
            if (checkCitiesActive(father) || checkNameActive(father)) {
              // locations_grouped.push(father)
              locations_grouped.push({ ...father, is: 'father' })
            } else {
              for (let children of getChildrens(father)) {
                if (
                  filters?.location.find(
                    (element) => element?.name?.toString() === children[0].toString(),
                  )
                ) {
                  // locations_grouped.push(children)
                  // locations_grouped.push(children)
                  locations_grouped.push({ ...children, is: 'children' })
                }
              }
            }
          }
        }
      }
    } else {
      if (summaryGenerals?.objects) {
        for (const country of summaryGenerals?.objects?.locations_tree) {
          for (const grandfather of country.data) {
            if (allNeighborhoodActivesByGrandfather(grandfather)) {
              locations_grouped.push({ ...grandfather, is: 'grandfather' })
            } else {
              for (const father of grandfather.data) {
                if (allNeighborhoodActives(father)) {
                  locations_grouped.push({ ...father, is: 'father' })
                } else {
                  for (const neighborhood of father.data) {
                    if (
                      filters.location.find(
                        (loc) => loc?.name?.toLowerCase() === neighborhood.name.toLowerCase(),
                      )
                    ) {
                      locations_grouped.push({ ...neighborhood, is: 'neighborhood' })
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    // for(let liteLocation of listLocationLite.data.objects.locations){
    //     if(filters.location.find(element => element.id === liteLocation.location_id)){
    //         locations_grouped.push([liteLocation.location_name,{name:liteLocation.location_name,id:liteLocation.location_id, "is":"children"}])
    //     }
    // }
    return locations_grouped
  }

  function getLocationsByGroup(
    types: DefaultPropertyFilter[],
    groupIds?: number[],
    groupName?: string,
  ) {
    if (groupIds?.length === 0 || !groupIds) {
      return types
    }
    let adapted = types

    if (
      types.find((type) => groupIds?.find((group) => group.toString() === type?.id?.toString()))
    ) {
      for (const id_type of groupIds) {
        adapted = adapted.filter(({ id }) => id?.toString() !== id_type.toString())
      }

      adapted.push({
        id: 0,
        name: groupName,
      })
    }

    return adapted
  }

  const updateLocationByGroup = (location: any) => {
    if (API_KEY) {
      switch (location.is) {
        case 'grandfather':
          return updateLocationByGrandFather(location) //
        case 'father':
          return updateLocationByParent(location) //
        case 'children':
          return updateLocationByChildren(location) //
      }
    } else {
      let newLocations = filters?.location
      newLocations = newLocations?.filter(
        (element) => element?.name?.toLowerCase() !== location.name.toLowerCase(),
      )
      for (const loc of location.data) {
        //recorro todos los datas y desactivo
        newLocations = newLocations?.filter(
          (element) => element?.name?.toLowerCase() !== loc.name.toLowerCase(),
        )
        if (loc.data.length > 0) {
          for (const loc_father of loc.data) {
            //recorro todos los datas y desactivo
            newLocations = newLocations?.filter(
              (element) => element?.name?.toLowerCase() !== loc_father.name.toLowerCase(),
            )
          }
        }
      }
      return updateFilters(setAuxFilters, filters, 'allLocations', newLocations)
    }
  }

  const groupLocationMediacore = (summary: any) => {
    if (locationsAdv) {
      let locations = []
      let i = 0
      for (const country of summary?.objects?.locations_tree) {
        for (const state of country.data) {
          locations.push({ ...state, location_name: state.name, location_id: i, type: 'state' })
          i++
          for (const city of state.data) {
            locations.push({
              ...city,
              location_name: city.name,
              location_id: i,
              type: 'city',
              grandfather: state,
            })
            i++
            for (const neighborhood of city.data) {
              if (city.data.length > 1) {
                locations.push({
                  ...neighborhood,
                  location_name: neighborhood.name,
                  location_id: i,
                  type: 'neighborhood',
                })
                i++
              }
            }
          }
        }
      }
      return locations
    } else {
      return summary?.objects?.locations
    }
  }

  const checkResults = (type: any) => {
    if (type === 'location') {
      if (API_KEY) {
        for (let grandfather of getGrandfathers(advancedLocationsData)) {
          if (grandfather[0].toLowerCase().includes(searcher.toLowerCase())) {
            return false
          }
          for (let father of getFathers(grandfather)) {
            if (father[0].toLowerCase().includes(searcher.toLowerCase())) {
              return false
            }
            for (let children of getChildrens(father)) {
              if (children[0].toLowerCase().includes(searcher.toLowerCase())) {
                return false
              }
            }
          }
        }
      } else {
        if (
          groupLocationMediacore(summaryGenerals).filter((item: any) =>
            item.location_name.toLowerCase().includes(searcher.toLowerCase()),
          ).length > 0
        ) {
          return false
        }
        return true
      }
      return true
    } else {
      // for (let type of listFilters.data.objects.property_types) {
      //   if (type.type.toLowerCase().includes(searcherType.toLowerCase())) {
      //     return false
      //   }
      // }
      return true
    }
  }

  const allNeighborhoodActives = (father: any) => {
    for (let index = 0; index < father.data.length; index++) {
      const loc_neighborhood = father.data[index]
      if (!filters?.location.find((loc) => loc.name === loc_neighborhood.name)) {
        return false
      }
    }
    return true
  }

  const allNeighborhoodActivesByGrandfather = (grandfather: any) => {
    for (let index = 0; index < grandfather.data.length; index++) {
      const father = grandfather.data[index]
      if (!allNeighborhoodActives(father)) {
        return false
      }
    }
    return true
  }

  const updateLocationByGrandFatherMediacore = (grandfather: any) => {
    let newLocations = filters?.location
    let flag = false
    for (let index = 0; index < grandfather.data.length; index++) {
      const loc_father = grandfather.data[index]
      if (allNeighborhoodActivesByGrandfather(grandfather)) {
        const loc_neighborhoods = loc_father.data
        for (let index_nei = 0; index_nei < loc_neighborhoods.length; index_nei++) {
          const loc_neighborhood = loc_father.data[index_nei]
          newLocations = newLocations?.filter((loc) => loc.name !== loc_neighborhood.name)
        }
      } else {
        for (let index = 0; index < grandfather.data.length; index++) {
          const loc_father = grandfather.data[index]
          const loc_neighborhoods = loc_father.data
          for (let index_nei = 0; index_nei < loc_neighborhoods.length; index_nei++) {
            const loc_neighborhood = loc_father.data[index_nei]
            let loc_response = newLocations?.map((a) => a)
            loc_response?.push({ name: loc_neighborhood.name, type: 'neighborhood' })
            newLocations = loc_response
          }
        }
      }
      return updateFilters(setAuxFilters, filters, 'allLocations', newLocations)
    }
  }
  const updateLocationByFatherMediacore = (father: any, grandfather: any) => {
    let newLocations = filters?.location
    if (allNeighborhoodActivesByGrandfather(grandfather)) {
      for (let index = 0; index < grandfather.data.length; index++) {
        const loc_fathers = grandfather.data[index]
        const loc_neighborhoods = loc_fathers.data
        for (let index_nei = 0; index_nei < loc_neighborhoods.length; index_nei++) {
          const loc_neighborhood = loc_fathers.data[index_nei]
          newLocations = newLocations?.filter((loc) => loc.name !== loc_neighborhood.name)
        }
      }
      for (let index = 0; index < father.data.length; index++) {
        const loc_father = father.data[index]
        let loc_response = newLocations?.map((a) => a)
        loc_response?.push({ name: loc_father.name, type: 'neighborhood' })
        newLocations = loc_response
      }
    } else {
      if (allNeighborhoodActives(father)) {
        for (let index = 0; index < father.data.length; index++) {
          const loc_father = father.data[index]
          newLocations = newLocations?.filter((loc) => loc.name !== loc_father.name)
        }
      } else {
        for (let index = 0; index < father.data.length; index++) {
          const loc_father = father.data[index]
          let loc_response = newLocations?.map((a) => a)
          loc_response?.push({ name: loc_father.name, type: 'neighborhood' })
          newLocations = loc_response
        }
      }
    }
    return updateFilters(setAuxFilters, filters, 'allLocations', newLocations)
  }
  const updateLocationByChildrenMediacore = (children: any) => {
    let newLocations = []
    if (filters?.location.find((loc) => loc.name === children.name)) {
      newLocations = filters.location.filter((loc) => loc.name !== children.name) //desactivo el abuelo si esta activo
    } else {
      let loc_response: any = filters?.location?.map((a) => a)
      loc_response?.push({ name: children.name, type: 'neighborhood' })
      newLocations = loc_response
      //activo el abuelo si esta activo
    }
    return updateFilters(setAuxFilters, filters, 'allLocations', newLocations)
  }

  const updateLocationDynamic = (location: any, type: any) => {
    switch (type) {
      case 'state': {
        return updateLocationByGrandFatherMediacore(location)
      }
      case 'city': {
        return updateLocationByFatherMediacore(location, location.grandfather)
      }
      case 'neighborhood': {
        return updateLocationByChildrenMediacore(location)
      }
      default:
        return null
    }
  }

  const checkLocationDynamic = (location: any, type: any) => {
    switch (type) {
      case 'state': {
        return allNeighborhoodActivesByGrandfather(location)
      }
      case 'city': {
        return allNeighborhoodActives(location)
      }
      case 'neighborhood': {
        return filters?.location.find((loc) => loc.name === location.location_name)
      }
      default:
        return false
    }
  }

  function setIndexFilters(zIndex: string) {
    document.getElementById('handler-bar')!.style.zIndex = zIndex
  }

  const getStatusCollapse = (id: string) => {
    if (collapse_items?.find((item) => item.id === id)) {
      return collapse_items.find((item) => item.id === id)?.state
    }
    // let items = collapse_items?.map((item) => item)
    // items?.push({ id: id, state: false })
    // setCollapse_items(items)
    return false
  }

  const setStatusColapse = (id: string, state: boolean) => {
    if (!collapse_items?.find((item) => item.id === id)) {
      let items_in = collapse_items?.map((item) => item)
      items_in?.push({ id: id, state: true })
      return setCollapse_items(items_in)
    }
    let items = collapse_items?.map((item) => item)
    items?.forEach((item) => {
      if (item.id === id) {
        item.state = state
      }
    })
    setCollapse_items(items)
  }

  function valideGroupTypes(
    types: { count: number; id: number; type: string }[],
    groupIds?: number[],
    nameGroup?: string,
  ) {
    //Si no tiene grupos entonces no toco nada.
    if (!groupIds || !nameGroup) {
      return types
    }

    //Si tiene grupos, manejo grupos.
    let adapted = types
    let group = types.filter(({ id }) =>
      groupIds.find((id_g: number) => id?.toString() === id_g?.toString()),
    )
    for (const id_type of groupIds) {
      adapted = adapted.filter(({ id }) => id?.toString() !== id_type?.toString())
    }

    let totalCountGroup = 0

    for (let i = 0; i < group.length; i++) {
      totalCountGroup += group[i].count
    }

    adapted.push({
      count: totalCountGroup,
      id: 0,
      type: nameGroup,
    })

    if (idsPredefinidos) {
      return adapted
        .map((element: FilterPropertiesTokkoQuery) => element)
        .sort((a: any, b: any) => {
          return idsPredefinidos.indexOf(a.id) - idsPredefinidos.indexOf(b.id)
        })
    }
    return adapted
  }

  function valideActiveGroup(id: number) {
    if (!groupIds) {
      return false
    }
    if (id === 0) {
      if (filters.type.find((type) => groupIds.find((group: number) => group === type.id))) {
        return true
      }
    }
  }

  useEffect(() => {
    $(document).on('click', function (event) {
      // if (!$(event.target).closest('.collapse-filters').length) {
      if (
        !$(event.target).closest('.collapse-filters').length &&
        !$(event.target).closest('.content-filters-4').length
      ) {
        // Si el clic no ocurrió dentro del elemento con id "excludedElement"
        setMenu(false)
      }
    })
  }, [])

  return true ? (
    <>
      <aside
        id="sumary-filters"
        className={'filters-4 position absolute col-12 d-block not-closer position-relative'}
      >
        <form className={'collapse-filters not-closer ' + (menu ? 'open' : '')}>
          <div className="d-flex d-lg-none w-100">
            <h5 className="title-filters w-100 d-flex justify-content-between">
              Filtros:{' '}
              <div
                className="div close-btn"
                onClick={() => setMenu(false)}
              >
                <i></i>
                <i></i>
              </div>
            </h5>
          </div>
          <div
            className={
              'd-none d-lg-flex content-field not-closer ' + (!collapse_boxes.operation && 'close')
            }
          >
            <div
              className="not-closer dropdown-select btn btn-main no-hover"
              aria-expanded={collapse_boxes.operation}
              onClick={() => {
                setOpenAge(false)
                setOpenSurface(false)
                setOpenServices(false)
                setOpenTypeEnvoirments(false)
                setOpenGenerals(false)
                setOpenPrice(false)
                setOpenEnvironment(false)
                setOpenType(false)
                setOpenLocation(false)
                setOpenOperation(!openOperation)
                setCollapse_boxes({ ...collapse_boxes, operation: !collapse_boxes.operation })
              }}
            >
              Tipo de operación
              <i className="icon-arrow-light"></i>
            </div>
            <div className="not-closer float-select minimal-buttons">
              <Collapse in={collapse_boxes.operation}>
                <div>
                  {allSummaryData &&
                  allSummaryData.objects.operation_types.find(
                    (element: any) => element?.operation_type === 1,
                  ) ? (
                    <div className={'not-closer flex-input'}>
                      <input
                        className="not-closer"
                        onChange={() =>
                          updateFilters(setAuxFilters, auxFilters, 'operation', 'venta')
                        }
                        checked={checkCurrentFilters(filters, 'operation', 'venta')}
                        type="checkbox"
                        name="operation"
                        id={'venta'}
                        value={1}
                      />
                      <label
                        className="not-closer"
                        htmlFor={'venta'}
                      >
                        <div className="radio custom-span not-closer"></div>
                        {SALE.name} (
                        {
                          allSummaryData.objects.operation_types.find(
                            (element: any) => element.operation_type === 1,
                          )?.count
                        }
                        )
                      </label>
                    </div>
                  ) : (
                    ''
                  )}
                  {allSummaryData &&
                  allSummaryData.objects.operation_types.find(
                    (element: any) => element.operation_type === 2,
                  ) ? (
                    <div className={'not-closer flex-input'}>
                      <input
                        className="not-closer"
                        onChange={() =>
                          updateFilters(setAuxFilters, auxFilters, 'operation', 'alquiler')
                        }
                        checked={checkCurrentFilters(filters, 'operation', 'alquiler')}
                        type="checkbox"
                        name="operation"
                        id={'alquiler'}
                        value={2}
                      />
                      <label
                        className="not-closer"
                        htmlFor={'alquiler'}
                      >
                        <div className="radio custom-span not-closer"></div>
                        {RENT.name} (
                        {
                          allSummaryData.objects.operation_types.find(
                            (element: any) => element.operation_type === 2,
                          )?.count
                        }
                        )
                      </label>
                    </div>
                  ) : (
                    // <div onClick={() => updateFilters(setAuxFilters,auxFilters,"operation", "alquiler")} className='not-closer flex-input cursor-pointer'>
                    //     <div className={'radio-custom ' + (filters.operation === 'alquiler' && 'active')}>Alquiler</div>
                    // </div>
                    ''
                  )}
                  {allSummaryData &&
                  allSummaryData.objects.operation_types.find(
                    (element: any) => element.operation_type === 3,
                  ) ? (
                    <div className={'not-closer flex-input'}>
                      <input
                        className="not-closer"
                        onChange={() =>
                          updateFilters(setAuxFilters, auxFilters, 'operation', TEMPORARY.route)
                        }
                        checked={checkCurrentFilters(filters, 'operation', TEMPORARY.route)}
                        type="checkbox"
                        name="operation"
                        id={TEMPORARY.route}
                        value={2}
                      />
                      <label
                        className="not-closer"
                        htmlFor={TEMPORARY.route}
                      >
                        <div className="radio custom-span not-closer"></div>
                        {TEMPORARY.name} (
                        {
                          allSummaryData.objects.operation_types.find(
                            (element: any) => element.operation_type === 3,
                          )?.count
                        }
                        )
                      </label>
                    </div>
                  ) : (
                    ''
                  )}
                </div>
              </Collapse>
            </div>
          </div>
          <div
            className={
              'd-none d-lg-flex content-field not-closer ' + (!collapse_boxes.type && 'close')
            }
          >
            <div
              className="not-closer dropdown-select btn btn-main no-hover"
              onClick={(e) => {
                setOpenAge(false)
                setOpenSurface(false)
                setOpenServices(false)
                setOpenTypeEnvoirments(false)
                setOpenGenerals(false)
                setOpenPrice(false)
                setOpenEnvironment(false)
                setOpenOperation(false)
                setOpenLocation(false)
                setOpenType(!openType)
                e.preventDefault()
                setCollapse_boxes({ ...collapse_boxes, type: !collapse_boxes.type })
              }}
            >
              Tipo de propiedad
              <i className="icon-arrow-light"></i>
            </div>
            <div className="not-closer float-select minimal-buttons">
              <Collapse in={collapse_boxes.type}>
                <div>
                  {/* <option value="all">Tipo de propiedad</option> */}
                  {summaryByOperation
                    ? valideGroupTypes(
                        summaryByOperation.objects.property_types,
                        groupIds,
                        groupName,
                      ).map((item: any, index: number) => (
                        <div
                          key={index}
                          className={'not-closer flex-input '}
                        >
                          <input
                            className="not-closer"
                            onChange={() =>
                              updateFilters(
                                setAuxFilters,
                                auxFilters,
                                'type',
                                {
                                  id: item.id,
                                  name: item.type,
                                },
                                { groupIds: item.id === 0 ? groupIds : [] },
                              )
                            }
                            checked={
                              checkCurrentFilters(filters, 'type', item.type) ||
                              valideActiveGroup(item.id)
                            }
                            type="checkbox"
                            name=""
                            id={item.type}
                            value={item.type}
                          />
                          <label
                            className="not-closer"
                            htmlFor={item.type}
                          >
                            <div className="square custom-span not-closer"></div>
                            {item.type + ' '}(
                            {item.id === 0
                              ? item.count
                              : getTypeCount(summaryByOperation?.objects, item)}
                            )
                          </label>
                        </div>
                      ))
                    : ''}
                </div>
              </Collapse>
            </div>
          </div>
          <div
            className={
              'd-none d-lg-flex content-field not-closer ' + (!collapse_boxes.location && 'close')
            }
          >
            <div
              className="not-closer dropdown-select btn btn-main no-hover"
              onClick={(e) => {
                setOpenAge(false)
                setOpenSurface(false)
                setOpenServices(false)
                setOpenTypeEnvoirments(false)
                setOpenGenerals(false)
                setOpenPrice(false)
                setOpenEnvironment(false)
                setOpenOperation(false)
                setOpenType(false)
                setOpenLocation(!openLocation)
                e.preventDefault()
                setCollapse_boxes({ ...collapse_boxes, location: !collapse_boxes.location })
              }}
            >
              Ubicación
              <i className="icon-arrow-light"></i>
            </div>
            <div className="not-closer float-select minimal-buttons"></div>
            <Collapse in={collapse_boxes.location}>
              <div>
                <div className="not-closer height-custom location-width float-select minimal-buttons">
                  <input
                    type="text"
                    className="searcher not-closer d-block mb-2 mt-3"
                    placeholder="Buscar por ubicación"
                    name=""
                    value={searcher}
                    onChange={(e) => setSearcher(e.target.value)}
                    id=""
                  />
                  <div className={'my-wrapper position-relative not-closer '}>
                    {!locationsAdv ? (
                      summaryGenerals && (
                        <>
                          {api_key
                            ? summaryGenerals?.objects?.locations?.map(
                                (item: any, index: number) => (
                                  <div
                                    className="d-flex px-lg-3 w-100 align-items-center"
                                    key={index}
                                  >
                                    <label className={'not-closer option flex-input'}>
                                      <input
                                        id=""
                                        type="checkbox"
                                        checked={
                                          filters.location.find(
                                            (element) => element.id === item.location_id,
                                          )
                                            ? true
                                            : false
                                        }
                                        onChange={() =>
                                          updateLocationByChildren({
                                            id: item.location_id,
                                            name: item.location_name,
                                          })
                                        }
                                        className="not-closer radio-custom"
                                        name="location[]"
                                        value={item.location_name}
                                      />
                                      <span className="not-closer custom-input square "></span>{' '}
                                      <div className="mark-up not-closer">
                                        {''}
                                        <Markup content={toMarkup(item.location_name, searcher)} />
                                      </div>
                                    </label>
                                  </div>
                                ),
                              )
                            : summaryGenerals.objects.locations.map((item: any, index: number) => (
                                <div
                                  key={index}
                                  className={'not-closer flex-input '}
                                >
                                  <input
                                    className="not-closer"
                                    onChange={() =>
                                      updateFilters(setAuxFilters, auxFilters, 'location', {
                                        id: item.location_id,
                                        name: item.location_name,
                                        type: 'neighborhood',
                                      })
                                    }
                                    checked={checkCurrentFilters(filters, 'location', {
                                      id: item.location_id,
                                      name: item.location_name,
                                    })}
                                    type="checkbox"
                                    name=""
                                    id={item.location_name}
                                    value={item.location_name}
                                  />
                                  <label
                                    className="not-closer"
                                    htmlFor={item.location_name}
                                  >
                                    <div className="square custom-span not-closer"></div>
                                    {item.location_name +
                                      // ", " +
                                      // item.parent_name +
                                      ' asdaasd ' +
                                      `(${item.count})`}
                                  </label>
                                </div>
                              ))}
                        </>
                      )
                    ) : (
                      <>
                        {searcher !== '' ? (
                          <>
                            {API_KEY
                              ? summaryGenerals?.objects?.locations.map(
                                  (item: any, i: number) =>
                                    item.location_name
                                      .toLowerCase()
                                      .includes(searcher.toLowerCase()) && (
                                      <div
                                        key={i}
                                        className="d-flex px-lg-3 w-100 align-items-center"
                                      >
                                        <label className={'not-closer option flex-input'}>
                                          <input
                                            id=""
                                            type="checkbox"
                                            checked={
                                              filters?.location.find(
                                                (element) => element.id === item.location_id,
                                              )
                                                ? true
                                                : false
                                            }
                                            onChange={() =>
                                              updateLocationByChildren({
                                                id: item.location_id,
                                                name: item.location_name,
                                              })
                                            }
                                            className="not-closer radio-custom"
                                            name="location[]"
                                            value={item.location_name}
                                          />
                                          <span className="not-closer custom-input square "></span>{' '}
                                          <div className="mark-up not-closer">
                                            {' '}
                                            <Markup
                                              content={toMarkup(item.location_name, searcher)}
                                            />
                                          </div>
                                        </label>
                                      </div>
                                    ),
                                )
                              : groupLocationMediacore(summaryGenerals).map(
                                  (item: any, i: number) =>
                                    item.location_name
                                      .toLowerCase()
                                      .includes(searcher.toLowerCase()) && (
                                      <div
                                        key={i}
                                        className="d-flex px-lg-3 w-100 align-items-center"
                                      >
                                        <label className={'not-closer option flex-input'}>
                                          <input
                                            id=""
                                            type="checkbox"
                                            checked={
                                              checkLocationDynamic(item, item.type) ? true : false
                                            }
                                            onChange={() => updateLocationDynamic(item, item.type)}
                                            className="not-closer radio-custom"
                                            name="location[]"
                                            value={item.location_name}
                                          />
                                          <span className="not-closer custom-input square "></span>{' '}
                                          <div className="mark-up not-closer">
                                            {' '}
                                            <Markup
                                              content={toMarkup(item.location_name, searcher)}
                                            />
                                          </div>
                                        </label>
                                      </div>
                                    ),
                                )}
                            {checkResults('location') && (
                              <span className="mb-4">
                                No hay resultados sobre <b> "{searcher}"</b>.
                              </span>
                            )}
                          </>
                        ) : API_KEY ? (
                          getGrandfathers(advancedLocationsData).map(
                            (
                              item,
                              i, // List the grandfathers
                            ) => (
                              <div
                                key={i}
                                className={''}
                              >
                                <div className="d-flex px-lg-3 w-100 align-items-center not-closer justify-content-start w-custom">
                                  <div
                                    className={
                                      'me-2 open-collapse not-closer d-inline-flex ' +
                                      (!getStatusCollapse(normalizeName(item[0]))
                                        ? 'collapsed'
                                        : '')
                                    }
                                    aria-controls={'collapse-location-' + normalizeName(item[0])}
                                    aria-expanded={getStatusCollapse(normalizeName(item[0]))}
                                    onClick={() =>
                                      setStatusColapse(
                                        normalizeName(item[0]),
                                        !getStatusCollapse(normalizeName(item[0])),
                                      )
                                    }
                                  >
                                    <div className={'symbol not-closer'}></div>{' '}
                                  </div>
                                  <label className={'mb-0 option flex-input not-closer'}>
                                    <input
                                      onChange={() => updateLocationByGrandFather(item)}
                                      checked={checkAllFatherActives(item)}
                                      id=""
                                      type="checkbox"
                                      className="radio-custom not-closer "
                                      name="location[]"
                                      value={item[0]}
                                    />
                                    <span className="custom-input not-closer square"></span>{' '}
                                    {item[0].replace('**(.*)**', '<b>$1</b>')}
                                  </label>
                                </div>
                                <Collapse in={getStatusCollapse(normalizeName(item[0]))}>
                                  <div
                                    className="detail-collapse not-height not-closer "
                                    id={'collapse-location-' + normalizeName(item[0])}
                                  >
                                    {getFathers(item).map((father, index) => (
                                      <div
                                        key={index}
                                        className="d-flex flex-column justify-content-content mb-0 align-items-start not-closer w-custom childrens"
                                      >
                                        <div className="d-flex align-items-center w-100 justify-content-center not-closer ">
                                          <div
                                            className={
                                              'me-2 open-collapse not-closer d-inline-flex ' +
                                              (getChildrens(father).length <= 1
                                                ? ' opacity '
                                                : '') +
                                              (!getStatusCollapse(normalizeName(father[0]))
                                                ? 'collapsed'
                                                : '')
                                            }
                                            aria-controls={
                                              'collapse-location-' + normalizeName(father[0])
                                            }
                                            aria-expanded={getStatusCollapse(
                                              normalizeName(father[0]),
                                            )}
                                            onClick={() =>
                                              setStatusColapse(
                                                normalizeName(father[0]),
                                                !getStatusCollapse(normalizeName(father[0])),
                                              )
                                            }
                                          >
                                            <div className={'symbol not-closer'}></div>{' '}
                                          </div>

                                          <label className={'option not-closer flex-input'}>
                                            <input
                                              onChange={() => updateLocationByParent(father)}
                                              checked={
                                                checkCitiesActive(father) &&
                                                !checkAllFatherActives(item)
                                              }
                                              type="checkbox"
                                              className="not-closer radio-custom"
                                              name="location[]"
                                              value={father[0]}
                                            />
                                            <span className="not-closer custom-input square my-0"></span>{' '}
                                            {father[0]}
                                          </label>
                                        </div>
                                        <Collapse in={getStatusCollapse(normalizeName(father[0]))}>
                                          <div
                                            className="detail-collapse children not-height not-closer mb-2 childrens"
                                            id={'collapse-location-' + normalizeName(father[0])}
                                          >
                                            {getChildrens(father).map((children: any, index) => (
                                              <label
                                                key={index}
                                                className={'not-closer option flex-input'}
                                              >
                                                <input
                                                  id=""
                                                  type="checkbox"
                                                  checked={
                                                    filters?.location.find(
                                                      (element) => element.id === children[1]?.id!,
                                                    ) && !checkAllFatherActives(item)
                                                  }
                                                  onChange={() =>
                                                    updateLocationByChildren({
                                                      id: children[1]?.id!,
                                                      name: children[0],
                                                    })
                                                  }
                                                  className="not-closer radio-custom"
                                                  name="location[]"
                                                  value={children[0]}
                                                />
                                                <span className="not-closer  custom-input square my-0"></span>{' '}
                                                {children[0]}
                                              </label>
                                            ))}
                                          </div>
                                        </Collapse>
                                      </div>
                                    ))}
                                  </div>
                                </Collapse>
                              </div>
                            ),
                          )
                        ) : (
                          <>
                            {summaryGenerals?.objects?.locations_tree?.map((country: any) =>
                              country.data.map((grandfather: any, i: number) => (
                                <div
                                  key={i}
                                  className={''}
                                >
                                  <div className="d-flex px-lg-3 w-100 align-items-center not-closer justify-content-start w-custom">
                                    <div
                                      className={
                                        'me-2 open-collapse not-closer d-inline-flex ' +
                                        (!getStatusCollapse(normalizeName(grandfather.name))
                                          ? 'collapsed'
                                          : '')
                                      }
                                      aria-controls={
                                        'collapse-location-' + normalizeName(grandfather.name)
                                      }
                                      aria-expanded={getStatusCollapse(
                                        normalizeName(grandfather.name),
                                      )}
                                      onClick={() =>
                                        setStatusColapse(
                                          normalizeName(grandfather.name),
                                          !getStatusCollapse(normalizeName(grandfather.name)),
                                        )
                                      }
                                    >
                                      <div className={'symbol not-closer'}></div>{' '}
                                    </div>
                                    <label className={'mb-0 option flex-input not-closer'}>
                                      {/* <input onChange={() => updateLocationByGrandFather(grandfather)} checked={checkAllFatherActives(grandfather)} id="" type="checkbox" className="radio-custom not-closer " name="location[]" value={grandfather.name} /> */}
                                      <input
                                        id=""
                                        checked={allNeighborhoodActivesByGrandfather(grandfather)}
                                        onChange={() =>
                                          updateLocationByGrandFatherMediacore(grandfather)
                                        }
                                        type="checkbox"
                                        className="radio-custom not-closer "
                                        name="location[]"
                                        value={grandfather.name}
                                      />
                                      <span className="custom-input not-closer square"></span>{' '}
                                      {grandfather.name.replace('**(.*)**', '<b>$1</b>')}
                                    </label>
                                  </div>
                                  <Collapse in={getStatusCollapse(normalizeName(grandfather.name))}>
                                    <div
                                      className="detail-collapse not-height not-closer "
                                      id={'collapse-location-' + normalizeName(grandfather.name)}
                                    >
                                      {grandfather.data.map((father: any, i: number) => (
                                        <div
                                          key={i}
                                          className="d-flex flex-column justify-content-content mb-0 align-items-start not-closer w-custom childrens"
                                        >
                                          <div className="d-flex align-items-center w-100 justify-content-center not-closer ">
                                            <div
                                              className={
                                                'me-2 not-closer open-collapse d-inline-flex ' +
                                                (father.data.length <= 1 ? ' opacity ' : '') +
                                                (!getStatusCollapse(normalizeName(father.name))
                                                  ? ' collapsed'
                                                  : '')
                                              }
                                              aria-controls={
                                                'collapse-location-' + normalizeName(father.name)
                                              }
                                              aria-expanded={getStatusCollapse(
                                                normalizeName(father.name),
                                              )}
                                              onClick={() =>
                                                setStatusColapse(
                                                  normalizeName(father.name),
                                                  !getStatusCollapse(normalizeName(father.name)),
                                                )
                                              }
                                            >
                                              <div className={'symbol not-closer'}></div>{' '}
                                            </div>
                                            <label className={'option not-closer flex-input'}>
                                              {/* <input onChange={() => updateLocationByParent(father) } checked={checkCitiesActive(father) && !checkAllFatherActives(item)}  type="checkbox" className="not-closer radio-custom"  name="location[]" value={father.name} /> */}
                                              <input
                                                type="checkbox"
                                                // checked={filters.location.find(element =>element.name === father.name) && !filters.location.find(element =>element.name === grandfather.name) && allNeighborhoodActives(father)}
                                                checked={
                                                  allNeighborhoodActives(father) &&
                                                  !allNeighborhoodActivesByGrandfather(grandfather)
                                                }
                                                onChange={() =>
                                                  updateLocationByFatherMediacore(
                                                    father,
                                                    grandfather,
                                                  )
                                                }
                                                className="not-closer radio-custom"
                                                name="location[]"
                                                value={father.name}
                                              />
                                              <span className="not-closer custom-input square my-0"></span>{' '}
                                              {father.name}
                                            </label>
                                          </div>
                                          <Collapse
                                            in={getStatusCollapse(normalizeName(father.name))}
                                          >
                                            <div
                                              className="detail-collapse children not-height not-closer mb-2 childrens"
                                              id={'collapse-location-' + normalizeName(father.name)}
                                            >
                                              {father.data.map((children: any, index: number) => (
                                                <label
                                                  key={index}
                                                  className={'not-closer option flex-input'}
                                                >
                                                  <input
                                                    checked={
                                                      filters?.location.find(
                                                        (element) => element.name === children.name,
                                                      )
                                                        ? true
                                                        : false
                                                    }
                                                    onChange={() =>
                                                      updateLocationByChildrenMediacore(children)
                                                    }
                                                    id=""
                                                    type="checkbox"
                                                    className="not-closer radio-custom"
                                                    name="location[]"
                                                    value={children.name}
                                                  />
                                                  <span className="not-closer  custom-input square my-0"></span>{' '}
                                                  {children.name}
                                                </label>
                                              ))}
                                            </div>
                                          </Collapse>
                                        </div>
                                      ))}
                                    </div>
                                  </Collapse>
                                </div>
                              )),
                            )}
                          </>
                        )}
                        <div className="control-float position-sticky w-100 d-flex justify-content-center not-closer">
                          <button
                            onClick={(e) => {
                              updateFilters(setAuxFilters, filters, 'allLocations', [])
                              e.preventDefault()
                            }}
                            className="btn btn-white me-1 not-closer"
                          >
                            Limpiar
                          </button>
                          {/* <button
                        onClick={() => setOpenLocation(false)}
                        className="btn btn-black ms-1 border not-closer"
                      >
                        Aplicar
                      </button> */}
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </Collapse>
          </div>
          <div
            className={
              'd-none d-lg-flex content-field not-closer position-relative ' +
              (!collapse_boxes.bedrooms && ' close ') +
              (!checkEnvironmentExist() ? ' d-lg-none ' : ' d-lg-flex')
            }
          >
            <div
              className="not-closer dropdown-select btn btn-main no-hover"
              onClick={(e) => {
                filters?.bedrooms !== ''
                  ? setBedrooms({
                      min: filters?.bedrooms?.split('-')[0],
                      max: filters?.bedrooms?.split('-')[1],
                    })
                  : ''
                filters?.environments !== ''
                  ? setEnvironments({
                      min: filters?.environments.split('-')[0],
                      max: filters?.environments.split('-')[1],
                    })
                  : ''
                setOpenAge(false)
                setOpenSurface(false)
                setOpenServices(false)
                setOpenTypeEnvoirments(false)
                setOpenGenerals(false)
                setOpenPrice(false)
                setOpenOperation(false)
                setOpenLocation(false)
                setOpenType(false)
                setOpenEnvironment(!openEnvironment)
                e.preventDefault()
                setCollapse_boxes({ ...collapse_boxes, bedrooms: !collapse_boxes.bedrooms })
              }}
            >
              Amb | Dorm
              <i className="icon-arrow-light"></i>
            </div>
            <div className="not-closer float-select minimal-buttons not-height">
              <Collapse in={collapse_boxes.bedrooms}>
                <div>
                  <p className="not-closer title mb-4">Ambientes</p>
                  <div className="d-flex not-closer">
                    <div
                      className={
                        'd-none d-lg-block content-field not-closer me-2 ' +
                        (!openMinEnvironment && 'close')
                      }
                    >
                      <div
                        className="not-closer dropdown-select minimal-select btn btn-main no-hover justify-content-between"
                        onClick={() => setOpenMinEnvironment(!openMinEnvironment)}
                      >
                        {environments.min === ''
                          ? 'Mínimo'
                          : (environments.min.toString() === '99' ? '+9' : environments.min) +
                            ' amb'}
                        <i className="icon-arrow-light not-closer"></i>
                      </div>
                      <div className="w-auto not-closer float-select minimal-buttons position-relative">
                        <div
                          className={
                            'not-closer flex-input ' +
                            (!checkEnvironment(summaryGenerals?.objects, 1) && 'd-none')
                          }
                        >
                          <input
                            className="not-closer"
                            onChange={() => updateEnvironment('min', 1)}
                            checked={environments.min.toString() === '1'}
                            type="radio"
                            id="amb-sumary-1-min"
                            name="roomsMin"
                            value="1"
                          />
                          <label
                            className="not-closer"
                            htmlFor={'amb-sumary-1-min'}
                          >
                            <div className="custom-span not-closer"></div>1 amb
                          </label>
                        </div>
                        <div
                          className={
                            'not-closer flex-input ' +
                            (!checkEnvironment(summaryGenerals?.objects, 2) && 'd-none')
                          }
                        >
                          <input
                            className="not-closer"
                            onChange={() => updateEnvironment('min', 2)}
                            checked={environments.min.toString() === '2'}
                            type="radio"
                            id="amb-sumary-2-min"
                            name="roomsMin"
                            value="2"
                          />
                          <label
                            className="not-closer"
                            htmlFor={'amb-sumary-2-min'}
                          >
                            <div className="custom-span not-closer"></div>2 amb
                          </label>
                        </div>
                        <div
                          className={
                            'not-closer flex-input ' +
                            (!checkEnvironment(summaryGenerals?.objects, 3) && 'd-none')
                          }
                        >
                          <input
                            className="not-closer"
                            onChange={() => updateEnvironment('min', 3)}
                            checked={environments.min.toString() === '3'}
                            type="radio"
                            id="amb-sumary-3-min"
                            name="roomsMin"
                            value="3"
                          />
                          <label
                            className="not-closer"
                            htmlFor={'amb-sumary-3-min'}
                          >
                            <div className="custom-span not-closer"></div>3 amb
                          </label>
                        </div>
                        <div
                          className={
                            'not-closer flex-input ' +
                            (!checkEnvironment(summaryGenerals?.objects, 4) && 'd-none')
                          }
                        >
                          <input
                            className="not-closer"
                            onChange={() => updateEnvironment('min', 4)}
                            checked={environments.min.toString() === '4'}
                            type="radio"
                            id="amb-sumary-4-min"
                            name="roomsMin"
                            value="4"
                          />
                          <label
                            className="not-closer"
                            htmlFor={'amb-sumary-4-min'}
                          >
                            <div className="custom-span not-closer"></div>4 amb
                          </label>
                        </div>
                        <div
                          className={
                            'not-closer flex-input ' +
                            (!checkEnvironment(summaryGenerals?.objects, 5) && 'd-none')
                          }
                        >
                          <input
                            className="not-closer"
                            onChange={() => updateEnvironment('min', 5)}
                            checked={environments.min.toString() === '5'}
                            type="radio"
                            id="amb-sumary-5-min"
                            name="roomsMin"
                            value="5"
                          />
                          <label
                            className="not-closer"
                            htmlFor={'amb-sumary-5-min'}
                          >
                            <div className="custom-span not-closer"></div>5 amb
                          </label>
                        </div>
                        <div
                          className={
                            'not-closer flex-input ' +
                            (!checkEnvironment(summaryGenerals?.objects, 6) && 'd-none')
                          }
                        >
                          <input
                            className="not-closer"
                            type="radio"
                            onChange={() => updateEnvironment('min', 6)}
                            checked={environments.min.toString() === '6'}
                            id="amb-sumary-6-min"
                            name="roomsMin"
                            value="6"
                          />
                          <label
                            className="not-closer"
                            htmlFor={'amb-sumary-6-min'}
                          >
                            <div className="custom-span not-closer"></div>6 amb
                          </label>
                        </div>
                        <div
                          className={
                            'not-closer flex-input ' +
                            (!checkEnvironment(summaryGenerals?.objects, 7) && 'd-none')
                          }
                        >
                          <input
                            className="not-closer"
                            type="radio"
                            onChange={() => updateEnvironment('min', 7)}
                            checked={environments.min.toString() === '7'}
                            id="amb-sumary-7-min"
                            name="roomsMin"
                            value="7"
                          />
                          <label
                            className="not-closer"
                            htmlFor={'amb-sumary-7-min'}
                          >
                            <div className="custom-span not-closer"></div>7 amb
                          </label>
                        </div>
                        <div
                          className={
                            'not-closer flex-input ' +
                            (!checkEnvironment(summaryGenerals?.objects, 8) && 'd-none')
                          }
                        >
                          <input
                            className="not-closer"
                            type="radio"
                            onChange={() => updateEnvironment('min', 8)}
                            checked={environments.min.toString() === '8'}
                            id="amb-sumary-8-min"
                            name="roomsMin"
                            value="8"
                          />
                          <label
                            className="not-closer"
                            htmlFor={'amb-sumary-8-min'}
                          >
                            <div className="custom-span not-closer"></div>8 amb
                          </label>
                        </div>
                        <div
                          className={
                            'not-closer flex-input ' +
                            (!checkEnvironment(summaryGenerals?.objects, 9) && 'd-none')
                          }
                        >
                          <input
                            className="not-closer"
                            type="radio"
                            onChange={() => updateEnvironment('min', 99)}
                            checked={environments.min.toString() === '99'}
                            id="amb-sumary-9-min"
                            name="roomsMin"
                            value="9"
                          />
                          <label
                            className="not-closer"
                            htmlFor={'amb-sumary-9-min'}
                          >
                            <div className="custom-span not-closer"></div>+9 amb
                          </label>
                        </div>
                      </div>
                    </div>
                    <div
                      className={
                        'd-none d-lg-block content-field not-closer ms-2 ' +
                        (!openMaxEnvironment && 'close')
                      }
                    >
                      <div
                        className="not-closer dropdown-select minimal-select btn btn-main no-hover"
                        onClick={() => setOpenMaxEnvironment(!openMaxEnvironment)}
                      >
                        {environments.max === ''
                          ? 'Máximo'
                          : (environments.max.toString() === '99'
                              ? '+9'
                              : environments.max.toString()) + ' amb'}
                        <i className="icon-arrow-light not-closer"></i>
                      </div>
                      <div className="not-closer float-select minimal-buttons position-relative">
                        <div
                          className={
                            'not-closer flex-input ' +
                            ((!checkEnvironment(summaryGenerals?.objects, 1) ||
                              environments.min > '1') &&
                              'd-none')
                          }
                        >
                          <input
                            className="not-closer"
                            onChange={() => updateEnvironment('max', 1)}
                            checked={environments.max.toString() === '1'}
                            type="radio"
                            id="amb-sumary-1-max"
                            name="roomsMax"
                            value="1"
                          />
                          <label
                            className="not-closer"
                            htmlFor={'amb-sumary-1-max'}
                          >
                            <div className="custom-span not-closer"></div>1 amb
                          </label>
                        </div>
                        <div
                          className={
                            'not-closer flex-input ' +
                            ((!checkEnvironment(summaryGenerals?.objects, 2) ||
                              environments.min > '2') &&
                              'd-none')
                          }
                        >
                          <input
                            className="not-closer"
                            onChange={() => updateEnvironment('max', 2)}
                            checked={environments.max.toString() === '2'}
                            type="radio"
                            id="amb-sumary-2-max"
                            name="roomsMax"
                            value="2"
                          />
                          <label
                            className="not-closer"
                            htmlFor={'amb-sumary-2-max'}
                          >
                            <div className="custom-span not-closer"></div>2 amb
                          </label>
                        </div>
                        <div
                          className={
                            'not-closer flex-input ' +
                            ((!checkEnvironment(summaryGenerals?.objects, 3) ||
                              environments.min > '3') &&
                              'd-none')
                          }
                        >
                          <input
                            className="not-closer"
                            onChange={() => updateEnvironment('max', 3)}
                            checked={environments.max.toString() === '3'}
                            type="radio"
                            id="amb-sumary-3-max"
                            name="roomsMax"
                            value="3"
                          />
                          <label
                            className="not-closer"
                            htmlFor={'amb-sumary-3-max'}
                          >
                            <div className="custom-span not-closer"></div>3 amb
                          </label>
                        </div>
                        <div
                          className={
                            'not-closer flex-input ' +
                            ((!checkEnvironment(summaryGenerals?.objects, 4) ||
                              environments.min > '4') &&
                              'd-none')
                          }
                        >
                          <input
                            className="not-closer"
                            onChange={() => updateEnvironment('max', 4)}
                            checked={environments.max.toString() === '4'}
                            type="radio"
                            id="amb-sumary-4-max"
                            name="roomsMax"
                            value="4"
                          />
                          <label
                            className="not-closer"
                            htmlFor={'amb-sumary-4-max'}
                          >
                            <div className="custom-span not-closer"></div>4 amb
                          </label>
                        </div>
                        <div
                          className={
                            'not-closer flex-input ' +
                            ((!checkEnvironment(summaryGenerals?.objects, 5) ||
                              environments.min > '5') &&
                              'd-none')
                          }
                        >
                          <input
                            className="not-closer"
                            onChange={() => updateEnvironment('max', 5)}
                            checked={environments.max.toString() === '5'}
                            type="radio"
                            id="amb-sumary-5-max"
                            name="roomsMax"
                            value="5"
                          />
                          <label
                            className="not-closer"
                            htmlFor={'amb-sumary-5-max'}
                          >
                            <div className="custom-span not-closer"></div>5 amb
                          </label>
                        </div>
                        <div
                          className={
                            'not-closer flex-input ' +
                            ((!checkEnvironment(summaryGenerals?.objects, 6) ||
                              environments.min > '6') &&
                              'd-none')
                          }
                        >
                          <input
                            className="not-closer"
                            type="radio"
                            onChange={() => updateEnvironment('max', 6)}
                            checked={environments.max.toString() === '6'}
                            id="amb-sumary-6-max"
                            name="roomsMax"
                            value="6"
                          />
                          <label
                            className="not-closer"
                            htmlFor={'amb-sumary-6-max'}
                          >
                            <div className="custom-span not-closer"></div>6 amb
                          </label>
                        </div>
                        <div
                          className={
                            'not-closer flex-input ' +
                            ((!checkEnvironment(summaryGenerals?.objects, 7) ||
                              environments.min > '7') &&
                              'd-none')
                          }
                        >
                          <input
                            className="not-closer"
                            type="radio"
                            onChange={() => updateEnvironment('max', 7)}
                            checked={environments.max.toString() === '7'}
                            id="amb-sumary-7-max"
                            name="roomsMax"
                            value="7"
                          />
                          <label
                            className="not-closer"
                            htmlFor={'amb-sumary-7-max'}
                          >
                            <div className="custom-span not-closer"></div>7 amb
                          </label>
                        </div>
                        <div
                          className={
                            'not-closer flex-input ' +
                            ((!checkEnvironment(summaryGenerals?.objects, 8) ||
                              environments.min > '8') &&
                              'd-none')
                          }
                        >
                          <input
                            className="not-closer"
                            type="radio"
                            onChange={() => updateEnvironment('max', 8)}
                            checked={environments.max.toString() === '8'}
                            id="amb-sumary-8-max"
                            name="roomsMax"
                            value="8"
                          />
                          <label
                            className="not-closer"
                            htmlFor={'amb-sumary-8-max'}
                          >
                            <div className="custom-span not-closer"></div>8 amb
                          </label>
                        </div>
                        <div
                          className={
                            'not-closer flex-input ' +
                            ((!checkEnvironment(summaryGenerals?.objects, 9) ||
                              environments.min > '9') &&
                              'd-none')
                          }
                        >
                          <input
                            className="not-closer"
                            type="radio"
                            onChange={() => updateEnvironment('max', 99)}
                            checked={environments.max.toString() === '99'}
                            id="amb-sumary-9-max"
                            name="roomsMax"
                            value="9"
                          />
                          <label
                            className="not-closer"
                            htmlFor={'amb-sumary-9-max'}
                          >
                            <div className="custom-span not-closer"></div>+9 amb
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  {summaryGenerals ? <></> : ''}
                  <p className={'not-closer title ' + (!checkBedroomExist() && 'd-none')}>
                    Dormitorios
                  </p>
                  <div className={'d-flex not-closer ' + (!checkBedroomExist() && 'd-none')}>
                    <div
                      className={
                        'd-none d-lg-block content-field not-closer me-2 ' +
                        (!openMinBedrooms && 'close')
                      }
                    >
                      <div
                        className="not-closer dropdown-select minimal-select btn btn-main no-hover justify-content-between"
                        onClick={() => setOpenMinBedrooms(!openMinBedrooms)}
                      >
                        {bedrooms.min === ''
                          ? 'Mínimo'
                          : (bedrooms.min.toString() === '99' ? '+9' : bedrooms.min) + ' dorm'}
                        <i className="icon-arrow-light not-closer"></i>
                      </div>
                      <div className="w-auto not-closer float-select minimal-buttons position-relative">
                        <div
                          className={
                            'not-closer flex-input ' +
                            (!checkBedroom(summaryGenerals?.objects, 1) && 'd-none')
                          }
                        >
                          <input
                            className="not-closer"
                            onChange={() => updateBedroom('min', 1)}
                            checked={bedrooms.min.toString() === '1'}
                            type="radio"
                            id="bed-sumary-1"
                            name="bedMin"
                            value="1"
                          />
                          <label
                            className="not-closer"
                            htmlFor={'bed-sumary-1'}
                          >
                            <div className="custom-span not-closer"></div>1 dorm
                          </label>
                        </div>
                        <div
                          className={
                            'not-closer flex-input ' +
                            (!checkBedroom(summaryGenerals?.objects, 2) && 'd-none')
                          }
                        >
                          <input
                            className="not-closer"
                            onChange={() => updateBedroom('min', 2)}
                            checked={bedrooms.min.toString() === '2'}
                            type="radio"
                            id="bed-sumary-2-min"
                            name="bedMin"
                            value="2"
                          />
                          <label
                            className="not-closer"
                            htmlFor={'bed-sumary-2-min'}
                          >
                            <div className="custom-span not-closer"></div>2 dorm
                          </label>
                        </div>
                        <div
                          className={
                            'not-closer flex-input ' +
                            (!checkBedroom(summaryGenerals?.objects, 3) && 'd-none')
                          }
                        >
                          <input
                            className="not-closer"
                            onChange={() => updateBedroom('min', 3)}
                            checked={bedrooms.min.toString() === '3'}
                            type="radio"
                            id="bed-sumary-3-min"
                            name="bedMin"
                            value="3"
                          />
                          <label
                            className="not-closer"
                            htmlFor={'bed-sumary-3-min'}
                          >
                            <div className="custom-span not-closer"></div>3 dorm
                          </label>
                        </div>
                        <div
                          className={
                            'not-closer flex-input ' +
                            (!checkBedroom(summaryGenerals?.objects, 4) && 'd-none')
                          }
                        >
                          <input
                            className="not-closer"
                            onChange={() => updateBedroom('min', 4)}
                            checked={bedrooms.min.toString() === '4'}
                            type="radio"
                            id="bed-sumary-4-min"
                            name="bedMin"
                            value="4"
                          />
                          <label
                            className="not-closer"
                            htmlFor={'bed-sumary-4-min'}
                          >
                            <div className="custom-span not-closer"></div>4 dorm
                          </label>
                        </div>
                        <div
                          className={
                            'not-closer flex-input ' +
                            (!checkBedroom(summaryGenerals?.objects, 5) && 'd-none')
                          }
                        >
                          <input
                            className="not-closer"
                            onChange={() => updateBedroom('min', 5)}
                            checked={bedrooms.min.toString() === '5'}
                            type="radio"
                            id="bed-sumary-5-min"
                            name="bedMin"
                            value="5"
                          />
                          <label
                            className="not-closer"
                            htmlFor={'bed-sumary-5-min'}
                          >
                            <div className="custom-span not-closer"></div>5 dorm
                          </label>
                        </div>
                        <div
                          className={
                            'not-closer flex-input ' +
                            (!checkBedroom(summaryGenerals?.objects, 6) && 'd-none')
                          }
                        >
                          <input
                            className="not-closer"
                            type="radio"
                            onChange={() => updateBedroom('min', 6)}
                            checked={bedrooms.min.toString() === '6'}
                            id="bed-sumary-6-min"
                            name="bedMin"
                            value="6"
                          />
                          <label
                            className="not-closer"
                            htmlFor={'bed-sumary-6-min'}
                          >
                            <div className="custom-span not-closer"></div>6 dorm
                          </label>
                        </div>
                        <div
                          className={
                            'not-closer flex-input ' +
                            (!checkBedroom(summaryGenerals?.objects, 7) && 'd-none')
                          }
                        >
                          <input
                            className="not-closer"
                            type="radio"
                            onChange={() => updateBedroom('min', 7)}
                            checked={bedrooms.min.toString() === '7'}
                            id="bed-sumary-7-min"
                            name="bedMin"
                            value="7"
                          />
                          <label
                            className="not-closer"
                            htmlFor={'bed-sumary-7-min'}
                          >
                            <div className="custom-span not-closer"></div>7 dorm
                          </label>
                        </div>
                        <div
                          className={
                            'not-closer flex-input ' +
                            (!checkBedroom(summaryGenerals?.objects, 8) && 'd-none')
                          }
                        >
                          <input
                            className="not-closer"
                            type="radio"
                            onChange={() => updateBedroom('min', 8)}
                            checked={bedrooms.min.toString() === '8'}
                            id="bed-sumary-8-min"
                            name="bedMin"
                            value="8"
                          />
                          <label
                            className="not-closer"
                            htmlFor={'bed-sumary-8-min'}
                          >
                            <div className="custom-span not-closer"></div>8 dorm
                          </label>
                        </div>
                        <div
                          className={
                            'not-closer flex-input ' +
                            (!checkBedroom(summaryGenerals?.objects, 9) && 'd-none')
                          }
                        >
                          <input
                            className="not-closer"
                            type="radio"
                            onChange={() => updateBedroom('min', 99)}
                            checked={bedrooms.min.toString() === '99'}
                            id="bed-sumary-9-min"
                            name="bedMin"
                            value="9"
                          />
                          <label
                            className="not-closer"
                            htmlFor={'bed-sumary-9-min'}
                          >
                            <div className="custom-span not-closer"></div>+9 dorm
                          </label>
                        </div>
                      </div>
                    </div>
                    <div
                      className={
                        'd-none d-lg-block content-field not-closer ms-2 ' +
                        (!openMaxBedrooms && 'close')
                      }
                    >
                      <div
                        className="not-closer dropdown-select minimal-select btn btn-main no-hover "
                        onClick={() => setOpenMaxBedrooms(!openMaxBedrooms)}
                      >
                        {bedrooms.max === ''
                          ? 'Máximo'
                          : (bedrooms.max.toString() === '99' ? '+9' : bedrooms.max) + ' dorm'}
                        <i className="icon-arrow-light not-closer"></i>
                      </div>
                      <div className="not-closer float-select minimal-buttons position-relative">
                        <div
                          className={
                            'not-closer flex-input ' +
                            ((!checkBedroom(summaryGenerals?.objects, 1) || bedrooms.min > '1') &&
                              'd-none')
                          }
                        >
                          <input
                            className="not-closer"
                            onChange={() => updateBedroom('max', 1)}
                            checked={bedrooms.max.toString() === '1'}
                            type="radio"
                            id="bed-sumary-1-max"
                            name="bedMax"
                            value="1"
                          />
                          <label
                            className="not-closer"
                            htmlFor={'bed-sumary-1-max'}
                          >
                            <div className="custom-span not-closer"></div>1 dorm
                          </label>
                        </div>
                        <div
                          className={
                            'not-closer flex-input ' +
                            ((!checkBedroom(summaryGenerals?.objects, 2) || bedrooms.min > '2') &&
                              'd-none')
                          }
                        >
                          <input
                            className="not-closer"
                            onChange={() => updateBedroom('max', 2)}
                            checked={bedrooms.max.toString() === '2'}
                            type="radio"
                            id="bed-sumary-2-max"
                            name="bedMax"
                            value="2"
                          />
                          <label
                            className="not-closer"
                            htmlFor={'bed-sumary-2-max'}
                          >
                            <div className="custom-span not-closer"></div>2 dorm
                          </label>
                        </div>
                        <div
                          className={
                            'not-closer flex-input ' +
                            ((!checkBedroom(summaryGenerals?.objects, 3) || bedrooms.min > '3') &&
                              'd-none')
                          }
                        >
                          <input
                            className="not-closer"
                            onChange={() => updateBedroom('max', 3)}
                            checked={bedrooms.max.toString() === '3'}
                            type="radio"
                            id="bed-sumary-3-max"
                            name="bedMax"
                            value="3"
                          />
                          <label
                            className="not-closer"
                            htmlFor={'bed-sumary-3-max'}
                          >
                            <div className="custom-span not-closer"></div>3 dorm
                          </label>
                        </div>
                        <div
                          className={
                            'not-closer flex-input ' +
                            ((!checkBedroom(summaryGenerals?.objects, 4) || bedrooms.min > '4') &&
                              'd-none')
                          }
                        >
                          <input
                            className="not-closer"
                            onChange={() => updateBedroom('max', 4)}
                            checked={bedrooms.max.toString() === '4'}
                            type="radio"
                            id="bed-sumary-4-max"
                            name="bedMax"
                            value="4"
                          />
                          <label
                            className="not-closer"
                            htmlFor={'bed-sumary-4-max'}
                          >
                            <div className="custom-span not-closer"></div>4 dorm
                          </label>
                        </div>
                        <div
                          className={
                            'not-closer flex-input ' +
                            ((!checkBedroom(summaryGenerals?.objects, 5) || bedrooms.min > '5') &&
                              'd-none')
                          }
                        >
                          <input
                            className="not-closer"
                            onChange={() => updateBedroom('max', 5)}
                            checked={bedrooms.max.toString() === '5'}
                            type="radio"
                            id="bed-sumary-5-max"
                            name="bedMax"
                            value="5"
                          />
                          <label
                            className="not-closer"
                            htmlFor={'bed-sumary-5-max'}
                          >
                            <div className="custom-span not-closer"></div>5 dorm
                          </label>
                        </div>
                        <div
                          className={
                            'not-closer flex-input ' +
                            ((!checkBedroom(summaryGenerals?.objects, 6) || bedrooms.min > '6') &&
                              'd-none')
                          }
                        >
                          <input
                            className="not-closer"
                            type="radio"
                            onChange={() => updateBedroom('max', 6)}
                            checked={bedrooms.max.toString() === '6'}
                            id="bed-sumary-6-max"
                            name="bedMax"
                            value="6"
                          />
                          <label
                            className="not-closer"
                            htmlFor={'bed-sumary-6-max'}
                          >
                            <div className="custom-span not-closer"></div>6 dorm
                          </label>
                        </div>
                        <div
                          className={
                            'not-closer flex-input ' +
                            ((!checkBedroom(summaryGenerals?.objects, 7) || bedrooms.min > '7') &&
                              'd-none')
                          }
                        >
                          <input
                            className="not-closer"
                            type="radio"
                            onChange={() => updateBedroom('max', 7)}
                            checked={bedrooms.max.toString() === '7'}
                            id="bed-sumary-7-max"
                            name="bedMax"
                            value="7"
                          />
                          <label
                            className="not-closer"
                            htmlFor={'bed-sumary-7-max'}
                          >
                            <div className="custom-span not-closer"></div>7 dorm
                          </label>
                        </div>
                        <div
                          className={
                            'not-closer flex-input ' +
                            ((!checkBedroom(summaryGenerals?.objects, 8) || bedrooms.min > '8') &&
                              'd-none')
                          }
                        >
                          <input
                            className="not-closer"
                            type="radio"
                            onChange={() => updateBedroom('max', 8)}
                            checked={bedrooms.max.toString() === '8'}
                            id="bed-sumary-8-max"
                            name="bedMax"
                            value="8"
                          />
                          <label
                            className="not-closer"
                            htmlFor={'bed-sumary-8-max'}
                          >
                            <div className="custom-span not-closer"></div>8 dorm
                          </label>
                        </div>
                        <div
                          className={
                            'not-closer flex-input ' +
                            ((!checkBedroom(summaryGenerals?.objects, 9) || bedrooms.min > '9') &&
                              'd-none')
                          }
                        >
                          <input
                            className="not-closer"
                            type="radio"
                            onChange={() => updateBedroom('max', 99)}
                            checked={bedrooms.max.toString() === '99'}
                            id="bed-sumary-9-max"
                            name="bedMax"
                            value="9"
                          />
                          <label
                            className="not-closer"
                            htmlFor={'bed-sumary-9-max'}
                          >
                            <div className="custom-span not-closer"></div>+9 dorm
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  {summaryGenerals ? <></> : ''}
                </div>
              </Collapse>
            </div>
          </div>
          <div
            className={
              'd-none d-lg-flex content-field not-closer minimal-buttons ' +
              (!collapse_boxes.price && ' close ')
            }
          >
            <div
              className="not-closer dropdown-select btn btn-main no-hover"
              onClick={(e) => {
                setOpenAge(false)
                setOpenSurface(false)
                setOpenServices(false)
                setOpenTypeEnvoirments(false)
                setOpenGenerals(false)
                setOpenOperation(false)
                setOpenLocation(false)
                setOpenType(false)
                setOpenEnvironment(false)
                setOpenPrice(!openPrice)
                e.preventDefault()
                setCollapse_boxes({ ...collapse_boxes, price: !collapse_boxes.price })
              }}
            >
              Precio
              <i className="icon-arrow-light"></i>
            </div>
            <div className="not-closer float-select minimal-buttons w-auto">
              <Collapse in={collapse_boxes.price}>
                <div>
                  <div className={'not-closer flex-input ' + (!lowPrice && 'd-none')}>
                    <input
                      className="not-closer"
                      onChange={() => updateFilters(setAuxFilters, auxFilters, 'is_off', null)}
                      checked={checkCurrentFilters(filters, 'is_off', true)}
                      type="checkbox"
                      id="is_off"
                      name="is_off"
                    />
                    <label
                      className="not-closer"
                      htmlFor={'is_off'}
                    >
                      <div className="square custom-span not-closer"></div>
                      Propiedades retasadas
                    </label>
                  </div>
                  <div className="d-flex not-closer">
                    <div className={'not-closer flex-input no-hover pe-3'}>
                      <input
                        className="not-closer"
                        onClick={() =>
                          setAuxiliarPrice({
                            ...auxiliarValuesPrice,
                            priceType: 'pesos',
                          })
                        }
                        readOnly
                        checked={auxiliarValuesPrice.priceType.toLowerCase() === 'pesos'}
                        type="radio"
                        id="price-ars"
                        name="price"
                        value="2"
                      />
                      <label
                        className="not-closer"
                        htmlFor="price-ars"
                      >
                        <div className="custom-span not-closer radio"></div>Pesos
                      </label>
                    </div>
                    <div className={'not-closer flex-input no-hover pe-5'}>
                      <input
                        className="not-closer"
                        onClick={() =>
                          setAuxiliarPrice({
                            ...auxiliarValuesPrice,
                            priceType: 'dolares',
                          })
                        }
                        readOnly
                        checked={auxiliarValuesPrice.priceType.toLowerCase() === 'dolares'}
                        type="radio"
                        id="price-dolar"
                        name="price"
                        value="2"
                      />
                      <label
                        className="not-closer"
                        htmlFor="price-dolar"
                      >
                        <div className="custom-span not-closer radio"></div>Dólares
                      </label>
                    </div>
                  </div>
                  <div className="row px-3 mt-3 input-range not-closer">
                    <div className="col-6 not-closer">
                      <input
                        className="not-closer"
                        type="text"
                        placeholder="Desde"
                        disabled={!auxiliarValuesPrice.priceType}
                        onFocus={() => setHelpers({ ...helpers, minprice: 1 })}
                        onChange={(e) => handleInputPriceMin(e.target.value)}
                        value={
                          parseInt(auxiliarValuesPrice.priceMin.toString()).toLocaleString(
                            'es-AR',
                          ) !== 'NaN'
                            ? parseInt(auxiliarValuesPrice.priceMin.toString()).toLocaleString(
                                'es-AR',
                              )
                            : ''
                        }
                      />
                      <div
                        className={
                          'cursor-pointer not-closer price-helper ' +
                          (helpers.minprice ? '' : 'd-none')
                        }
                      >
                        {pricesDefault.map((price, index) => (
                          <div
                            onClick={() => {
                              setAuxiliarPrice({
                                ...auxiliarValuesPrice,
                                priceMin: price,
                              })
                              setHelpers({ ...helpers, minprice: 0 })
                            }}
                            key={index}
                            className="price-helper-item not-closer "
                          >
                            {Intl.NumberFormat('de-DE').format(price)}
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="col-6 not-closer">
                      <input
                        className="not-closer"
                        type="text"
                        disabled={!auxiliarValuesPrice.priceType}
                        placeholder="Hasta"
                        onFocus={() => setHelpers({ ...helpers, maxprice: 1 })}
                        onChange={(e) => handleInputPriceMax(e.target.value)}
                        value={
                          parseInt(auxiliarValuesPrice?.priceMax.toString()).toLocaleString(
                            'es-AR',
                          ) !== 'NaN'
                            ? parseInt(auxiliarValuesPrice?.priceMax.toString()).toLocaleString(
                                'es-AR',
                              )
                            : ''
                        }
                      />
                      <div
                        className={
                          'cursor-pointer price-helper not-closer ' +
                          (helpers.maxprice ? '' : 'd-none')
                        }
                      >
                        {pricesDefault.map((price, index) =>
                          price > parseInt(auxiliarValuesPrice.priceMin.toString()) ? (
                            <div
                              onClick={() => {
                                setAuxiliarPrice({
                                  ...auxiliarValuesPrice,
                                  priceMax: price,
                                })
                                setHelpers({ ...helpers, maxprice: 0 })
                              }}
                              key={index}
                              className="price-helper-item not-closer "
                            >
                              {Intl.NumberFormat('de-DE').format(price)}
                            </div>
                          ) : null,
                        )}
                      </div>
                    </div>
                    <div className="control-float position-sticky w-100 d-flex justify-content-center not-closer">
                      <button
                        disabled={
                          !auxiliarValuesPrice?.priceType ||
                          !auxiliarValuesPrice?.priceMax ||
                          !auxiliarValuesPrice?.priceMin
                        }
                        onClick={(e) => {
                          sendAuxiliar()
                          e.preventDefault()
                          setOpenPrice(false)
                        }}
                        className="w-100 btn btn-black ms-1 border not-closer"
                      >
                        Aplicar
                      </button>
                    </div>
                  </div>
                </div>
              </Collapse>
            </div>
          </div>
          <div
            className={
              'd-none d-lg-flex content-field not-closer ' + (!collapse_boxes.surface && ' close ')
            }
          >
            <div
              className="not-closer dropdown-select btn btn-main no-hover"
              onClick={(e) => {
                setOpenAge(false)
                setOpenServices(false)
                setOpenOperation(false)
                setOpenTypeEnvoirments(false)
                setOpenGenerals(false)
                setOpenLocation(false)
                setOpenType(false)
                setOpenEnvironment(false)
                setOpenPrice(false)
                setOpenSurface(!openSurface)
                e.preventDefault()
                setCollapse_boxes({ ...collapse_boxes, surface: !collapse_boxes.surface })
              }}
            >
              Superficie
              <i className="icon-arrow-light"></i>
            </div>
            <div className="not-closer float-select minimal-buttons w-auto">
              <Collapse in={collapse_boxes.surface}>
                <div>
                  <div className="d-flex">
                    <div className={'not-closer flex-input no-hover pe-5'}>
                      <input
                        className="not-closer"
                        onClick={() =>
                          setAuxiliarSurface({
                            ...auxiliarValuesSurface,
                            surfaceType: 'cubierta',
                          })
                        }
                        readOnly
                        checked={auxiliarValuesSurface.surfaceType === 'cubierta'}
                        type="radio"
                        id="cub"
                        name="surface_type"
                        value="CUB"
                      />
                      <label
                        className="not-closer"
                        htmlFor="cub"
                      >
                        <div className="custom-span not-closer radio"></div>Cubierta
                      </label>
                    </div>
                    <div className={'not-closer flex-input no-hover pe-5'}>
                      <input
                        className="not-closer"
                        onClick={() =>
                          setAuxiliarSurface({
                            ...auxiliarValuesSurface,
                            surfaceType: 'total',
                          })
                        }
                        readOnly
                        checked={auxiliarValuesSurface.surfaceType === 'total'}
                        type="radio"
                        id="tot"
                        name="surface_type"
                        value="TOT"
                      />
                      <label
                        className="not-closer"
                        htmlFor="tot"
                      >
                        <div className="custom-span not-closer radio"></div>Total
                      </label>
                    </div>
                  </div>
                  <div className="row px-3 mt-3 not-closer input-range">
                    <div className="col-6 not-closer">
                      <input
                        className="not-closer"
                        type="text"
                        placeholder="Desde"
                        disabled={!auxiliarValuesSurface.surfaceType}
                        onChange={(e) =>
                          setAuxiliarSurface({
                            ...auxiliarValuesSurface,
                            surfaceMin: e.target.value,
                          })
                        }
                        value={auxiliarValuesSurface.surfaceMin}
                      />
                    </div>
                    <div className="col-6 d-flex not-closer align-items-center">
                      <input
                        className="not-closer"
                        type="text"
                        placeholder="Hasta"
                        disabled={!auxiliarValuesSurface.surfaceType}
                        onChange={(e) =>
                          setAuxiliarSurface({
                            ...auxiliarValuesSurface,
                            surfaceMax: e.target.value,
                          })
                        }
                        value={auxiliarValuesSurface.surfaceMax}
                      />
                      <div
                        className="ms-1 mb-2 not-closer"
                        style={{ fontSize: '.8rem' }}
                      >
                        m2
                      </div>
                    </div>
                    <div className="control-float position-sticky w-100 d-flex justify-content-center not-closer">
                      <button
                        disabled={
                          !auxiliarValuesSurface.surfaceType ||
                          !auxiliarValuesSurface.surfaceMax ||
                          !auxiliarValuesSurface.surfaceMin
                        }
                        onClick={(e) => {
                          sendAuxiliar()
                          e.preventDefault()
                          setOpenSurface(false)
                        }}
                        className="w-100 btn btn-black ms-1 border not-closer"
                      >
                        Aplicar
                      </button>
                    </div>
                  </div>
                </div>
              </Collapse>
            </div>
          </div>
          <div
            className={
              'content-field ' +
              (getGenerals(summaryGenerals?.objects)?.length === 0 &&
              getServices(summaryGenerals?.objects)?.length === 0 &&
              getEnvironment(summaryGenerals?.objects)?.length === 0
                ? ' d-none '
                : 'd-none d-lg-flex ') +
              (!collapse_boxes.generals && ' close ')
            }
          >
            <div
              className="not-closer dropdown-select btn btn-main no-hover"
              onClick={(e) => {
                setOpenAge(false)
                setOpenOperation(false)
                setOpenLocation(false)
                setOpenType(false)
                setOpenEnvironment(false)
                setOpenPrice(false)
                setOpenSurface(false)
                setOpenServices(false)
                setOpenTypeEnvoirments(false)
                setOpenGenerals(!openGenerals)
                e.preventDefault()
                setCollapse_boxes({ ...collapse_boxes, generals: !collapse_boxes.generals })
              }}
            >
              Generales
              <i className="icon-arrow-light"></i>
            </div>
            <div className="not-closer float-select minimal-buttons small">
              <Collapse in={collapse_boxes.generals}>
                <div>
                  <div
                    className="position-sticky not-closer py-2"
                    style={{
                      top: '0',
                      backgroundColor: '#fff',
                      position: 'sticky',
                      zIndex: '999',
                    }}
                  >
                    <input
                      type="text"
                      className="searcher auto ms-lg-4 not-closer d-block"
                      placeholder="Buscar por nombre"
                      name=""
                      value={searcherGeneral}
                      onChange={(e) => setSearcherGeneral(e.target.value)}
                      id=""
                    />
                  </div>
                  {summaryGenerals ? (
                    getEnvironment(summaryGenerals?.objects).filter(
                      (g: any) => g?.tag_name.toLowerCase().includes(searcherGeneral.toLowerCase()),
                    )?.length > 0 ? (
                      <>
                        {' '}
                        <h6 className="mt-2 ms-4 not-closer">
                          {API_KEY ? 'Ambientes' : 'Amenities'}
                        </h6>{' '}
                        {getEnvironment(summaryGenerals?.objects)
                          .filter(
                            (g: any) =>
                              g?.tag_name.toLowerCase().includes(searcherGeneral.toLowerCase()),
                          )
                          ?.map((item, index) => (
                            <div
                              key={index}
                              className={
                                'not-closer flex-input ' +
                                (getTagCount(summaryGenerals?.objects, item) === 0 && 'd-none')
                              }
                            >
                              <input
                                className="not-closer"
                                onChange={() =>
                                  updateFilters(setAuxFilters, auxFilters, 'environments_types', {
                                    id: item.tag_id,
                                    name: item.tag_name,
                                  })
                                }
                                checked={checkCurrentFilters(filters, 'environments_types', {
                                  id: item.tag_id,
                                  name: item.tag_name,
                                })}
                                type="checkbox"
                                id={item.tag_id?.toString()}
                                name="amenities"
                                value={item.tag_id}
                              />
                              <label
                                className="not-closer"
                                htmlFor={item?.tag_id?.toString()}
                              >
                                <div className="square custom-span not-closer"></div>
                                {item.tag_name}
                              </label>
                            </div>
                          ))}
                      </>
                    ) : (
                      ''
                    )
                  ) : (
                    ''
                  )}
                  {summaryGenerals ? (
                    getServices(summaryGenerals?.objects).filter(
                      (g) => g?.tag_name!.toLowerCase().includes(searcherGeneral.toLowerCase()),
                    )?.length > 0 ? (
                      <>
                        {' '}
                        <h6 className="mt-3 ms-4 not-closer">Servicios</h6>{' '}
                        {getServices(summaryGenerals?.objects)
                          .filter(
                            (g: any) =>
                              g?.tag_name?.toLowerCase().includes(searcherGeneral.toLowerCase()),
                          )
                          ?.map((item, index) => (
                            <div
                              key={index}
                              className={
                                'not-closer flex-input ' +
                                (getTagCount(summaryGenerals?.objects, item) === 0 && 'd-none')
                              }
                            >
                              <input
                                className="not-closer"
                                onChange={() =>
                                  updateFilters(setAuxFilters, auxFilters, 'services', {
                                    id: item.tag_id,
                                    name: item.tag_name,
                                  })
                                }
                                checked={checkCurrentFilters(filters, 'services', {
                                  id: item.tag_id,
                                  name: item.tag_name,
                                })}
                                type="checkbox"
                                id={item?.tag_id?.toString()}
                                name="amenities"
                                value={item.tag_id}
                              />
                              <label
                                className="not-closer"
                                htmlFor={item?.tag_id?.toString()}
                              >
                                <div className="square custom-span not-closer"></div>
                                {item.tag_name}
                              </label>
                            </div>
                          ))}
                      </>
                    ) : (
                      ''
                    )
                  ) : (
                    ''
                  )}
                  {summaryGenerals ? (
                    getGenerals(summaryGenerals?.objects)?.filter((g: any) =>
                      g.tag_name.toLowerCase().includes(searcherGeneral.toLowerCase()),
                    )?.length > 0 ? (
                      <>
                        {' '}
                        <h6 className="mt-3 ms-4 not-closer">
                          {API_KEY ? 'Adicionales' : 'Generales'}
                        </h6>{' '}
                        {getGenerals(summaryGenerals?.objects)
                          .sort((a, b): any => {
                            getTagCount(summaryGenerals?.objects, a)! -
                              getTagCount(summaryGenerals?.objects, b)!
                          })
                          .filter((g: any) =>
                            g.tag_name.toLowerCase().includes(searcherGeneral.toLowerCase()),
                          )
                          ?.map((item, index) => (
                            <div
                              key={index}
                              className={
                                'not-closer flex-input ' +
                                (getTagCount(summaryGenerals?.objects, item) === 0 && 'd-none')
                              }
                            >
                              <input
                                className="not-closer"
                                onChange={() =>
                                  updateFilters(setAuxFilters, auxFilters, 'generals', {
                                    id: item.tag_id,
                                    name: item.tag_name,
                                  })
                                }
                                checked={checkCurrentFilters(filters, 'generals', {
                                  id: item.tag_id,
                                  name: item.tag_name,
                                })}
                                type="checkbox"
                                id={item.tag_id?.toString()}
                                name="amenities"
                                value={item.tag_id}
                              />
                              <label
                                className="not-closer"
                                htmlFor={item.tag_id?.toString()}
                              >
                                <div className="square custom-span not-closer"></div>
                                {item.tag_name}
                              </label>
                            </div>
                          ))}
                      </>
                    ) : (
                      ''
                    )
                  ) : (
                    ''
                  )}
                </div>
              </Collapse>
            </div>
          </div>
          <div className="current-filters-mobile d-lg-none d-block">
            <h5 className="title-filters">Filtros aplicados:</h5>
            <div className="current-filters-scroll-x ms-lg-4">
              {
                <div className="d-inline-block me-lg-2 me-1">
                  {
                    <div
                      className={
                        'tag tag-button d-inline-flex align-items-center justify-content-center ' +
                        filters?.operation?.toLowerCase()
                      }
                    >
                      {filters?.operation.replace('-', ' ') || 'Cargando..'}
                    </div>
                  }
                </div>
              }
              {locationsAdv &&
                groupLocations().map((item, index) => (
                  <div
                    className="d-inline-block"
                    key={index}
                  >
                    {
                      <div className="tag tag-button d-inline-flex align-items-center justify-content-center">
                        {API_KEY ? item[0] : item.name}{' '}
                        <div
                          onClick={() => updateLocationByGroup(item)}
                          className="btn-delete-tag cursor-pointer ms-2"
                        >
                          ×
                        </div>
                      </div>
                    }
                  </div>
                ))}
              {!locationsAdv &&
                filters?.location.map((item, index) => (
                  <div
                    className="d-inline-block"
                    key={index}
                  >
                    {
                      <div className="tag tag-button d-inline-flex align-items-center justify-content-center">
                        {item.name}{' '}
                        <div
                          onClick={() => updateFilters(setAuxFilters, filters, 'location', item)}
                          className="btn-delete-tag cursor-pointer ms-2"
                        >
                          ×
                        </div>
                      </div>
                    }
                  </div>
                ))}
              {getLocationsByGroup(filters?.type, groupIds, groupName).map((item, index) => (
                <div
                  key={index}
                  className="d-inline-block"
                >
                  {
                    <div className="tag tag-button d-inline-flex align-items-center justify-content-center">
                      {item.name}{' '}
                      <div
                        onClick={() =>
                          updateFilters(setAuxFilters, filters, 'type', item, {
                            groupIds:
                              item.id === 0
                                ? groupIds?.map((element) => parseInt(element.toString()))
                                : [],
                          })
                        }
                        className="btn-delete-tag cursor-pointer ms-2"
                      >
                        ×
                      </div>
                    </div>
                  }
                </div>
              ))}
              {filters?.price.is_off === true ? (
                <div className="d-inline-block me-lg-2 me-1">
                  {
                    <div className="tag tag-button d-inline-flex align-items-center justify-content-center">
                      Propiedades retasadas{' '}
                      <div
                        onClick={() => updateFilters(setAuxFilters, filters, 'is_off', 'null')}
                        className="btn-delete-tag cursor-pointer ms-2"
                      >
                        ×
                      </div>
                    </div>
                  }
                </div>
              ) : (
                ''
              )}
              {filters?.address !== '' && filters?.address !== undefined ? (
                <div className="d-inline-block me-lg-2 me-1">
                  {
                    <div className="tag tag-button d-inline-flex align-items-center justify-content-center">
                      Calle: {filters.address}{' '}
                      <div
                        onClick={() => updateFilters(setAuxFilters, filters, 'address', '')}
                        className="btn-delete-tag cursor-pointer ms-2"
                      >
                        ×
                      </div>
                    </div>
                  }
                </div>
              ) : (
                ''
              )}
              {filters?.price.type !== '' ? (
                <div className="d-inline-block me-lg-2 me-1">
                  {
                    <div className="tag tag-button d-inline-flex align-items-center justify-content-center">
                      {filters.price.type == 'dolares' ? 'Dólares' : filters.price.type}{' '}
                      <div
                        onClick={() => updateFilters(setAuxFilters, filters, 'price-type', 'null')}
                        className="btn-delete-tag cursor-pointer ms-2"
                      >
                        ×
                      </div>
                    </div>
                  }
                </div>
              ) : (
                ''
              )}
              {filters?.price.type !== '' ? (
                <div className="tag tag-button d-inline-flex align-items-center justify-content-center">
                  Desde: $ {filters?.price?.priceMin} Hasta: $ {filters?.price.priceMax}{' '}
                  <div
                    onClick={() => updateFilters(setAuxFilters, filters, 'price-type', 'null')}
                    className="btn-delete-tag cursor-pointer ms-2"
                  >
                    ×
                  </div>
                </div>
              ) : (
                ''
              )}
              {filters?.surface?.type !== '' ? (
                <div className="d-inline-block me-lg-2 me-1">
                  {
                    <div className="tag tag-button d-inline-flex align-items-center justify-content-center">
                      {filters?.surface?.type}{' '}
                      <div
                        onClick={() => updateFilters(setAuxFilters, filters, 'surface-type', '')}
                        className="btn-delete-tag cursor-pointer ms-2"
                      >
                        ×
                      </div>
                    </div>
                  }
                </div>
              ) : (
                ''
              )}
              {filters?.surface?.type !== '' ? (
                <div className="tag tag-button d-inline-flex align-items-center justify-content-center">
                  Desde: {filters?.surface?.surfaceMin} M2 Hasta: {filters?.surface?.surfaceMax} M2
                  <div
                    onClick={() => updateFilters(setAuxFilters, filters, 'surface-type', '')}
                    className="btn-delete-tag cursor-pointer ms-2"
                  >
                    ×
                  </div>
                </div>
              ) : (
                ''
              )}
              {filters?.environments !== '' ? (
                <div className="tag tag-button d-inline-flex align-items-center justify-content-center not-capitalize">
                  {filters?.environments?.split('-')[0] === filters?.environments?.split('-')[1]
                    ? filters?.environments?.split('-')[0] !== '0' &&
                      (filters?.environments?.split('-')[0].toString() === '99'
                        ? '+9'
                        : filters?.environments?.split('-')[0]) + ' amb'
                    : (filters?.environments?.split('-')[0] !== '0'
                        ? 'Desde ' + filters?.environments?.split('-')[0]
                        : '') +
                      (filters?.environments.split('-')[1] !== '99' ||
                      filters?.environments.split('-')[0] === '0'
                        ? ' hasta ' + filters?.environments.split('-')[1]
                        : '') +
                      ' amb'}
                  <div
                    onClick={() => updateFilters(setAuxFilters, filters, 'environments', '')}
                    className="btn-delete-tag cursor-pointer ms-2"
                  >
                    ×
                  </div>
                </div>
              ) : (
                ''
              )}
              {filters?.bedrooms !== '' ? (
                <div className="tag tag-button d-inline-flex align-items-center justify-content-center not-capitalize">
                  {filters?.bedrooms?.split('-')[0] === filters?.bedrooms?.split('-')[1]
                    ? filters?.bedrooms?.split('-')[0] !== '0' &&
                      (filters?.bedrooms?.split('-')[0].toString() === '99'
                        ? '+9'
                        : filters?.bedrooms?.split('-')[0]) + ' dorm'
                    : (filters?.bedrooms?.split('-')[0] !== '0'
                        ? 'Desde ' + filters?.bedrooms?.split('-')[0]
                        : '') +
                      (filters?.bedrooms.split('-')[1] !== '99' ||
                      filters.bedrooms.split('-')[0] === '0'
                        ? ' hasta ' + filters?.bedrooms.split('-')[1]
                        : '') +
                      ' dorm'}
                  <div
                    onClick={() => updateFilters(setAuxFilters, filters, 'bedrooms', '')}
                    className="btn-delete-tag cursor-pointer ms-2"
                  >
                    ×
                  </div>
                </div>
              ) : (
                ''
              )}
              {/* {filters.environments.map((item,index) =>(<div className="d-inline-block me-lg-2 me-1">{<div className="tag tag-button d-inline-flex align-items-center justify-content-center">{item.replaceAll(" Ambientes"," Amb").replaceAll(" Ambiente"," Amb")} <div onClick={() =>  updateFilters(setAuxFilters,filters,'environments',item)} className="btn-delete-tag cursor-pointer ms-2">×</div></div>}</div>))} */}
              {filters?.age !== '' && filters?.age !== undefined ? (
                <div className="tag tag-button d-inline-flex align-items-center justify-content-center">
                  {filters?.age} {filters.age?.includes('años') ? ' de antigüedad' : ''}
                  <div
                    onClick={() => updateFilters(setAuxFilters, filters, 'age', '')}
                    className="btn-delete-tag cursor-pointer ms-2"
                  >
                    ×
                  </div>
                </div>
              ) : (
                ''
              )}
              {/* {filters.environments !== ''? (<div className="d-inline-block me-lg-2 me-1">{<div className="tag tag-button d-inline-flex align-items-center justify-content-center">{filters.environments} <div onClick={() =>  updateFilters(setAuxFilters,filters,'environments',filters.environments)} className="btn-delete-tag cursor-pointer ms-2">×</div></div>}</div>):''} */}
              {filters?.environments_types.map((item, index) => (
                <div
                  key={index}
                  className="d-inline-block"
                >
                  {
                    <div className="tag tag-button d-inline-flex align-items-center justify-content-center">
                      {item.name}{' '}
                      <div
                        onClick={() =>
                          updateFilters(setAuxFilters, filters, 'environments_types', item)
                        }
                        className="btn-delete-tag cursor-pointer ms-2"
                      >
                        ×
                      </div>
                    </div>
                  }
                </div>
              ))}
              {filters?.services.map((item, index) => (
                <div
                  key={index}
                  className="d-inline-block"
                >
                  {
                    <div className="tag tag-button d-inline-flex align-items-center justify-content-center">
                      {item.name}{' '}
                      <div
                        onClick={() => updateFilters(setAuxFilters, filters, 'services', item)}
                        className="btn-delete-tag cursor-pointer ms-2"
                      >
                        ×
                      </div>
                    </div>
                  }
                </div>
              ))}
              {filters?.generals.map((item, index) => (
                <div
                  key={index}
                  className="d-inline-block"
                >
                  {
                    <div className="tag tag-button d-inline-flex align-items-center justify-content-center">
                      {item.name}{' '}
                      <div
                        onClick={() => updateFilters(setAuxFilters, filters, 'generals', item)}
                        className="btn-delete-tag cursor-pointer ms-2"
                      >
                        ×
                      </div>
                    </div>
                  }
                </div>
              ))}
            </div>
          </div>
        </form>
      </aside>
    </>
  ) : (
    ''
  )
}

export default Filters_Bar_4
